<template>
  <div class="sd-page">
    <!-- head -->
    <div class="sd-hero">
      <div class="sd-hero-text">
        <h3><span class="sd-mark" aria-hidden="true">س</span> التحكم في سعود</h3>
        <p>
          «{{ saved.name || 'سعود' }} — {{ saved.subtitle || 'المساعد الذكي بالذكاء الاصطناعي' }}» داخل لوحة المدرسة: يجيب عن الأسئلة من محتوى «المساعد الذكي»،
          ويصنع ملفات Excel و PDF والصور والرسوم البيانية من بيانات الصفحة نفسها داخل متصفح المدرسة. مجاني للمدارس بحد يومي لكل مدرسة.
        </p>
      </div>
      <div class="sd-hero-meta">
        <div><span>الحالة</span><b>{{ state != 'ready' ? '—' : saved.enabled ? 'يعمل' : 'متوقف' }}</b></div>
        <div><span>رسائل اليوم</span><b>{{ usage.data ? num(usage.data.totals.today_messages) : '—' }}</b></div>
        <div><span>الحد اليومي</span><b>{{ state == 'ready' ? saved.daily_limit + ' لكل مدرسة' : '—' }}</b></div>
        <div><span>النموذج</span><b dir="ltr">{{ state == 'ready' ? saved.model : '—' }}</b></div>
      </div>
    </div>

    <nav class="sd-tabs" aria-label="أقسام التحكم في سعود">
      <button v-for="t in tabs" :key="t.key" class="sd-tab" :class="{ active: tab == t.key }" @click="setTab(t.key)">
        <i :class="'fa ' + t.icon"></i> {{ t.title }}
        <span v-if="t.badge" class="sd-count">{{ t.badge }}</span>
      </button>
    </nav>

    <div v-if="state == 'loading'" class="card card-body text-center text-muted">
      <span><i class="fa fa-spinner fa-spin"></i> جاري التحميل...</span>
    </div>

    <!-- older server (no /admin/saud) or no connection: a friendly empty state -->
    <div v-else-if="state != 'ready'" class="card sd-empty">
      <div class="sd-empty-icon" :class="{ warn: state == 'error' }"><i class="fa" :class="state == 'missing' ? 'fa-plug' : 'fa-wifi'"></i></div>
      <h5>{{ state == 'missing' ? 'سعود غير متاح على هذا السيرفر بعد' : 'تعذر تحميل إعدادات سعود' }}</h5>
      <p v-if="state == 'missing'">
        السيرفر الحالي لا يحتوي على خدمة «سعود — المساعد الذكي بالذكاء الاصطناعي».
        بعد تحديث السيرفر (Nodejs) ستظهر هنا الإعدادات والتعليمات والاستهلاك والمحادثات.
      </p>
      <p v-else>{{ errorText || 'تحقق من الاتصال بالسيرفر ثم أعد المحاولة.' }}</p>
      <button class="btn btn-primary" @click="loadAll()"><i class="fa fa-refresh"></i> إعادة المحاولة</button>
    </div>

    <template v-else>
      <!-- ===================================================== الإعدادات -->
      <div v-show="tab == 'settings'" class="row">
        <div class="col-12 col-xl-7 g">
          <div class="card" :class="{ 'sd-on': saved.enabled }">
            <div class="card-body">
              <div class="custom-control custom-switch sd-big-switch">
                <input id="sd-on" type="checkbox" class="custom-control-input" :checked="saved.enabled" :disabled="busy" @change="setEnabled($event)">
                <label class="custom-control-label" for="sd-on">{{ saved.enabled ? 'سعود يعمل في لوحات المدارس' : 'سعود متوقف' }}</label>
              </div>
              <p class="mb-50 mt-1">
                <b>عند التفعيل:</b> يظهر زر «{{ saved.name || 'سعود' }}» العائم أسفل يسار كل صفحات لوحة المدرسة (حسابات المدارس ومشرفيها فقط — لا يظهر للمعلمين ولا في صفحات الدخول).
              </p>
              <p class="mb-0"><b>عند الإيقاف:</b> يختفي الزر من كل المدارس فوراً، ولا تُرسل أي رسالة للذكاء الاصطناعي.</p>
              <p v-if="!key.set" class="text-warning small mt-50 mb-0"><i class="fa fa-exclamation-triangle"></i> لا يوجد مفتاح Gemini محفوظ — لن يستطيع سعود الرد حتى تحفظه في «مركز الاتصالات».</p>
            </div>
          </div>

          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-id-badge"></i> الاسم والترحيب</h5></div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-5 form-group">
                  <label for="sd-name">الاسم</label>
                  <input id="sd-name" v-model.trim="form.name" maxlength="40" class="form-control" placeholder="سعود">
                </div>
                <div class="col-md-7 form-group">
                  <label for="sd-sub">الوصف تحت الاسم</label>
                  <input id="sd-sub" v-model.trim="form.subtitle" maxlength="80" class="form-control" placeholder="المساعد الذكي بالذكاء الاصطناعي">
                </div>
              </div>
              <div class="form-group mb-0">
                <label for="sd-welcome">رسالة الترحيب</label>
                <textarea id="sd-welcome" v-model="form.welcome" rows="3" maxlength="600" class="form-control" placeholder="أهلاً! أنا سعود…"></textarea>
                <small class="text-muted">أول رسالة يراها المستخدم عند فتح النافذة · {{ (form.welcome || '').length }} من 600 حرف</small>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-microchip"></i> النموذج والحد اليومي</h5></div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-7 form-group">
                  <label for="sd-model">النموذج</label>
                  <select id="sd-model" v-model="form.model" class="form-control" dir="ltr">
                    <option v-for="m in modelOptions" :key="m" :value="m">{{ m }}{{ m == defaults.model ? ' — الافتراضي' : '' }}</option>
                  </select>
                  <small class="text-muted d-block">
                    السعر لكل مليون توكن: إدخال <bdi dir="ltr">{{ rate(price(form.model).in) }}</bdi> · مخزّن مؤقتاً <bdi dir="ltr">{{ rate(price(form.model).cached) }}</bdi> · إخراج <bdi dir="ltr">{{ rate(price(form.model).out) }}</bdi>
                  </small>
                </div>
                <div class="col-md-5 form-group">
                  <label for="sd-limit">الحد اليومي لكل مدرسة</label>
                  <div class="sd-inline">
                    <input id="sd-limit" v-model.number="form.daily_limit" type="number" min="1" max="1000" class="form-control sd-num">
                    <span>رسالة في اليوم</span>
                  </div>
                  <small class="text-muted">من 1 إلى 1000 · يتجدد كل يوم بتوقيت الرياض. الافتراضي {{ defaults.daily_limit }}.</small>
                </div>
              </div>
              <div class="custom-control custom-switch">
                <input id="sd-shot" v-model="form.screenshot" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="sd-shot">السماح بإرفاق لقطة من الصفحة</label>
              </div>
              <small class="text-muted d-block sd-switch-help">
                خيار «إرفاق لقطة من الصفحة» في النافذة: صورة مصغرة (≤ 1280 بكسل) تُرسل فقط عندما يختارها المستخدم، لفهم الصفحة بدقة أكبر — تكلفتها أعلى قليلاً.
              </small>
            </div>
          </div>

          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0"><i class="fa fa-book"></i> معلومات الإجابات</h5>
              <router-link class="btn btn-sm btn-outline-primary" :to="{ name: 'ai-assistant' }"><i class="fa fa-pencil"></i> تعديل المحتوى في «المساعد الذكي»</router-link>
            </div>
            <div class="card-body">
              <p class="text-muted small">يجيب سعود عن أسئلة المدارس من محتوى صفحة «المساعد الذكي» (الخدمات والأسعار والتطبيقات والأسئلة الشائعة). يُرسل المحتوى مع كل رسالة، فحجمه يحدد معظم التكلفة.</p>
              <div class="sd-modes" role="radiogroup" aria-label="حجم المعلومات">
                <label class="sd-mode" :class="{ on: form.knowledge == 'compact' }">
                  <input v-model="form.knowledge" type="radio" name="sd-knowledge" value="compact" class="sd-mode-radio">
                  <span class="sd-mode-body">
                    <span class="sd-mode-title">مختصر <span class="sd-tag">موصى به</span> <span v-if="hasKStats" class="sd-size" dir="ltr">≈ {{ num(kStats.compact_tokens) }} tokens</span></span>
                    <small>أهم المعلومات فقط — أقل تكلفة وأسرع رداً.<template v-if="hasKStats"> ≈ <bdi dir="ltr">{{ usd(knowledgeCost('compact')) }}</bdi> لكل رسالة.</template></small>
                  </span>
                </label>
                <label class="sd-mode" :class="{ on: form.knowledge == 'full' }">
                  <input v-model="form.knowledge" type="radio" name="sd-knowledge" value="full" class="sd-mode-radio">
                  <span class="sd-mode-body">
                    <span class="sd-mode-title">كامل <span v-if="hasKStats" class="sd-size" dir="ltr">≈ {{ num(kStats.full_tokens) }} tokens</span></span>
                    <small>كل التفاصيل والأسئلة الشائعة — إجابات أدق في الأسئلة النادرة.<template v-if="hasKStats"> ≈ <bdi dir="ltr">{{ usd(knowledgeCost('full')) }}</bdi> لكل رسالة.</template></small>
                  </span>
                </label>
              </div>
              <small v-if="!hasKStats" class="text-muted d-block mt-50">لم يُرسل السيرفر أحجام المحتوى.</small>
              <small v-else class="text-muted d-block mt-50">التكلفة تقديرية للإدخال قبل التخزين المؤقت (يخفضه Gemini تلقائياً للرسائل المتتالية).</small>
            </div>
          </div>

          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0"><i class="fa fa-bolt"></i> الاختصارات السريعة</h5>
              <button class="btn btn-sm btn-flat" @click="form.quick_prompts = defaults.quick_prompts.slice()"><i class="fa fa-undo"></i> الافتراضية</button>
            </div>
            <div class="card-body">
              <p class="text-muted small mb-50">أزرار جاهزة تظهر تحت رسالة الترحيب، يضغطها المستخدم بدلاً من الكتابة.</p>
              <div class="sd-chips">
                <span v-for="(q, i) in form.quick_prompts" :key="i + q" class="sd-chip">
                  <button class="sd-chip-move" :disabled="i == 0" title="تقديم" :aria-label="'تقديم ' + q" @click="movePrompt(i, -1)"><i class="fa fa-chevron-right"></i></button>
                  <span class="sd-chip-text" title="اضغط للتعديل" @click="editPrompt(i)">{{ q }}</span>
                  <button class="sd-chip-x" :aria-label="'حذف ' + q" @click="form.quick_prompts.splice(i, 1)"><i class="fa fa-times"></i></button>
                </span>
                <span v-if="!form.quick_prompts.length" class="text-muted small">لا توجد اختصارات.</span>
              </div>
              <div class="sd-inline mt-1">
                <input v-model="promptInput" maxlength="80" class="form-control sd-grow" placeholder="اختصار جديد، مثل: اعمل رسم بياني للحضور" :disabled="form.quick_prompts.length >= 8" @keydown.enter.prevent="addPrompt()">
                <button class="btn btn-outline-primary" :disabled="!promptInput.trim() || form.quick_prompts.length >= 8" @click="addPrompt()"><i class="fa fa-plus"></i> إضافة</button>
              </div>
              <small class="text-muted">حتى 8 اختصارات، 80 حرفاً لكل اختصار · اضغط على اختصار لتعديله.</small>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-5 g">
          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-key"></i> مفتاح Gemini</h5></div>
            <div class="card-body">
              <div class="sd-key" :class="key.set ? 'ok' : 'bad'">
                <i class="fa" :class="key.set ? 'fa-check-circle' : 'fa-exclamation-circle'"></i>
                <div>
                  <b>{{ key.set ? 'المفتاح محفوظ' : 'لا يوجد مفتاح' }}</b>
                  <code v-if="key.set && key.hint" dir="ltr">{{ key.hint }}</code>
                  <small>{{ key.set ? 'سعود يستخدم نفس مفتاح المساعد الصوتي في «مركز الاتصالات».' : 'احفظ مفتاح Gemini في «مركز الاتصالات» ليعمل سعود.' }}</small>
                </div>
              </div>
              <router-link class="btn btn-sm btn-outline-primary mt-1" :to="{ name: 'callcenter', query: { tab: 'ai' } }"><i class="fa fa-headphones"></i> {{ key.set ? 'تغيير المفتاح' : 'إضافة المفتاح' }} في «مركز الاتصالات»</router-link>
              <small class="text-muted d-block mt-50">يبقى المفتاح مشفراً على السيرفر ولا يُرسل لأي متصفح أو تطبيق.</small>
            </div>
          </div>

          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0"><i class="fa fa-eye"></i> معاينة النافذة</h5>
              <small class="text-muted">كما تراها المدرسة</small>
            </div>
            <div class="card-body">
              <div class="sd-panel" :class="{ off: !form.enabled }">
                <div class="sd-panel-head">
                  <span class="sd-panel-av">{{ (form.name || 'س').charAt(0) }}</span>
                  <div class="sd-panel-name">
                    <b>{{ form.name || 'سعود' }}</b>
                    <small>{{ form.subtitle }}</small>
                  </div>
                  <span class="sd-panel-left">متبقي {{ limitNum }} من {{ limitNum }} اليوم</span>
                </div>
                <div class="sd-panel-body">
                  <div class="sd-bubble saud">{{ form.welcome || '…' }}</div>
                  <div class="sd-panel-chips">
                    <span v-for="(q, i) in form.quick_prompts" :key="i">{{ q }}</span>
                  </div>
                  <div class="sd-bubble me">صدّر جدول الغائبين إلى Excel</div>
                  <div class="sd-bubble saud">
                    جهزت لك الملف 👇
                    <div class="sd-mini-action"><i class="fa fa-file-excel-o"></i> الغائبون اليوم <span>تحميل Excel</span></div>
                  </div>
                </div>
                <div class="sd-panel-foot">
                  <label v-if="form.screenshot" class="sd-panel-shot"><input type="checkbox" disabled> إرفاق لقطة من الصفحة</label>
                  <div class="sd-panel-input"><span>اكتب سؤالك أو طلبك…</span><i class="fa fa-paper-plane"></i></div>
                </div>
                <div v-if="!form.enabled" class="sd-panel-offnote"><i class="fa fa-power-off"></i> سعود متوقف — لا يظهر للمدارس</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================================================== الإمكانيات والخيارات (SAUD_SPEC F1) -->
      <div v-show="tab == 'options'" class="row">
        <div class="col-12 col-xl-7 g">
          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0"><i class="fa fa-magic"></i> ما يستطيع سعود فعله</h5>
              <small class="text-muted">{{ actionsOn }} من {{ actionList.length }} مفعّلة</small>
            </div>
            <div class="card-body">
              <p class="text-muted small">إيقاف إمكانية يزيلها من أدوات Gemini ومن أزرار النافذة (طلب أصغر قليلاً)، ويبقى سعود يجيب عن الأسئلة نصياً.</p>
              <div class="sd-caps">
                <div v-for="a in actionList" :key="a.key" class="sd-cap" :class="[a.cls, { on: form.actions[a.key] }]">
                  <i class="fa sd-cap-icon" :class="a.icon"></i>
                  <div class="sd-cap-body">
                    <div class="custom-control custom-switch">
                      <input :id="'cap-' + a.key" v-model="form.actions[a.key]" type="checkbox" class="custom-control-input">
                      <label class="custom-control-label" :for="'cap-' + a.key">{{ a.title }}</label>
                    </div>
                    <small>{{ a.text }}</small>
                  </div>
                </div>
              </div>
              <div class="sd-sub" :class="{ 'sd-dim': !form.actions.custom_design }">
                <label for="sd-cd-max" class="mb-25">الحد الأقصى لطول التصميم المخصص (HTML)</label>
                <div class="sd-inline">
                  <input id="sd-cd-max" v-model.number="form.custom_design.max_chars" type="number" min="500" max="8000" step="500" class="form-control sd-num wide" :disabled="!form.actions.custom_design">
                  <span>حرف</span>
                  <small class="text-muted">≈ {{ num(Math.round(clampInt(form.custom_design.max_chars, 500, 8000, 4000) / 3)) }} توكن إخراج كحد أقصى (≈ <bdi dir="ltr">{{ usd(Math.round(clampInt(form.custom_design.max_chars, 500, 8000, 4000) / 3) * price(form.model).out / 1e6) }}</bdi>)</small>
                </div>
                <small class="text-muted d-block mt-25">
                  عندما لا يناسب الجدول أو البطاقات أو الملخص، يكتب Gemini قالب HTML قصيراً بعلامات فقط مثل
                  <code v-pre dir="ltr">{{title}}</code> و<code v-pre dir="ltr">{{#rows}}…{{/rows}}</code> — بلا بيانات — والمتصفح يملؤه ويحوّله إلى صورة أو PDF.
                </small>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-align-right"></i> أسلوب الإجابة</h5></div>
            <div class="card-body">
              <div class="sd-modes" role="radiogroup" aria-label="أسلوب الإجابة">
                <label v-for="o in styleOptions" :key="o.value" class="sd-mode" :class="{ on: form.answer_style == o.value }">
                  <input v-model="form.answer_style" type="radio" name="sd-style" :value="o.value" class="sd-mode-radio">
                  <span class="sd-mode-body">
                    <span class="sd-mode-title">{{ o.title }} <span v-if="o.value == 'short'" class="sd-tag">موصى به</span> <span class="sd-size" dir="ltr">≈ {{ o.min }}–{{ o.max }} tokens</span></span>
                    <small>{{ o.text }} حتى ≈ <bdi dir="ltr">{{ usd(o.max * price(form.model).out / 1e6) }}</bdi> للرد.</small>
                  </span>
                </label>
              </div>
              <small class="text-muted d-block mt-50">توكن الإخراج أغلى من الإدخال بـ {{ outRatio }} مرات تقريباً؛ الأسلوب القصير يوفّر أكثر من نصف تكلفة الرد. الملفات والرسوم لا تتأثر (البيانات لا يكتبها Gemini).</small>
            </div>
          </div>

          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-history"></i> الذاكرة وطول الرسالة</h5></div>
            <div class="card-body">
              <div class="form-group">
                <label for="sd-hist">الرسائل السابقة التي تُرسل مع كل رسالة: <b>{{ form.history_turns }}</b></label>
                <input id="sd-hist" v-model.number="form.history_turns" type="range" min="0" max="10" step="1" class="custom-range">
                <div class="sd-range-ends"><small>0</small><small>10</small></div>
                <small class="text-muted d-block">{{ historyHint }}</small>
              </div>
              <div class="form-group mb-0">
                <label for="sd-maxmsg">أقصى طول لرسالة المستخدم</label>
                <div class="sd-inline">
                  <input id="sd-maxmsg" v-model.number="form.max_message_chars" type="number" min="100" max="2000" step="50" class="form-control sd-num wide">
                  <span>حرف</span>
                  <small class="text-muted">من 100 إلى 2000 · ≈ {{ num(Math.round(clampInt(form.max_message_chars, 100, 2000, 1000) / 3)) }} توكن إدخال كحد أقصى</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-5 g">
          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-desktop"></i> الظهور في لوحة المدرسة</h5></div>
            <div class="card-body">
              <label class="d-block">مكان الزر العائم</label>
              <div class="sd-seg mb-1" role="radiogroup" aria-label="مكان الزر">
                <label :class="{ on: form.position == 'left' }"><input v-model="form.position" type="radio" name="sd-pos" value="left"><i class="fa fa-long-arrow-left"></i> يسار الشاشة</label>
                <label :class="{ on: form.position == 'right' }"><input v-model="form.position" type="radio" name="sd-pos" value="right"><i class="fa fa-long-arrow-right"></i> يمين الشاشة</label>
              </div>
              <div class="sd-minis" aria-hidden="true">
                <div class="sd-mini-desk">
                  <div class="sd-mini-top"></div>
                  <div class="sd-mini-side" :style="{ right: '0' }"></div>
                  <div class="sd-mini-lines"><span></span><span></span><span class="s"></span><span></span></div>
                  <span class="sd-mini-sup" :style="{ left: '10px', bottom: '10px' }"><i class="fa fa-headphones"></i></span>
                  <span class="sd-mini-fab" :style="miniFab(false)">س</span>
                </div>
                <div class="sd-mini-phone" :class="{ hidden: !form.show_on_mobile }">
                  <div class="sd-mini-top"></div>
                  <div class="sd-mini-lines"><span></span><span class="s"></span><span></span></div>
                  <span class="sd-mini-sup" :style="{ left: '6px', bottom: '8px' }"><i class="fa fa-headphones"></i></span>
                  <span v-if="form.show_on_mobile" class="sd-mini-fab sm" :style="miniFab(true)">س</span>
                  <span v-else class="sd-mini-off">مخفي</span>
                </div>
              </div>
              <small class="text-muted d-block mt-50">على اليسار يكون فوق زر الدعم الفني مباشرة (بدون تداخل).</small>
              <div class="custom-control custom-switch mt-1">
                <input id="sd-mobile" v-model="form.show_on_mobile" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="sd-mobile">إظهار سعود على الجوال</label>
              </div>
              <small class="text-muted d-block sd-switch-help">على الجوال تفتح النافذة بملء الشاشة.</small>
            </div>
          </div>

          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-clock-o"></i> أوقات الظهور</h5></div>
            <div class="card-body">
              <div class="custom-control custom-switch">
                <input id="sd-hours" v-model="form.hours.enabled" type="checkbox" class="custom-control-input">
                <label class="custom-control-label" for="sd-hours">{{ form.hours.enabled ? 'يظهر في أيام وساعات محددة فقط' : 'يظهر طوال الوقت' }}</label>
              </div>
              <div class="sd-hours" :class="{ 'sd-dim': !form.hours.enabled }">
                <div class="sd-days">
                  <button v-for="(d, i) in dayNames" :key="i" type="button" class="sd-day" :class="{ on: form.hours.days.indexOf(i) >= 0 }" :disabled="!form.hours.enabled" :aria-pressed="form.hours.days.indexOf(i) >= 0 ? 'true' : 'false'" @click="toggleDay(i)">{{ d }}</button>
                </div>
                <div class="sd-inline">
                  <div class="form-group mb-0">
                    <label for="sd-from" class="small mb-0">من الساعة</label>
                    <input id="sd-from" v-model="form.hours.from" type="time" class="form-control form-control-sm" :disabled="!form.hours.enabled">
                  </div>
                  <div class="form-group mb-0">
                    <label for="sd-to" class="small mb-0">إلى الساعة</label>
                    <input id="sd-to" v-model="form.hours.to" type="time" class="form-control form-control-sm" :disabled="!form.hours.enabled">
                  </div>
                </div>
                <small class="text-muted d-block mt-50">بتوقيت الرياض. خارج هذه الأوقات يختفي زر سعود من لوحات المدارس.</small>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0"><i class="fa fa-university"></i> المدارس التي ترى سعود</h5>
              <small v-if="form.schools.mode != 'all'" class="text-muted">{{ form.schools.ids.length }} مدرسة</small>
            </div>
            <div class="card-body">
              <div class="sd-seg sd-seg-wrap mb-1" role="radiogroup" aria-label="المدارس">
                <label :class="{ on: form.schools.mode == 'all' }"><input v-model="form.schools.mode" type="radio" name="sd-sc" value="all">كل المدارس</label>
                <label :class="{ on: form.schools.mode == 'allow' }"><input v-model="form.schools.mode" type="radio" name="sd-sc" value="allow">مدارس محددة فقط</label>
                <label :class="{ on: form.schools.mode == 'deny' }"><input v-model="form.schools.mode" type="radio" name="sd-sc" value="deny">الكل ما عدا</label>
              </div>
              <template v-if="form.schools.mode != 'all'">
                <p class="small mb-50" :class="form.schools.mode == 'allow' ? 'text-success' : 'text-danger'">
                  {{ form.schools.mode == 'allow' ? 'يظهر سعود لهذه المدارس فقط:' : 'يظهر سعود لكل المدارس ما عدا:' }}
                </p>
                <div class="sd-school-list">
                  <div v-for="id in form.schools.ids" :key="id" class="sd-school">
                    <i class="fa fa-university"></i>
                    <div><b>{{ schoolNames[id] || 'مدرسة' }}</b><small dir="ltr">{{ id }}</small></div>
                    <button class="btn btn-sm btn-flat text-danger" :aria-label="'إزالة ' + (schoolNames[id] || id)" @click="removeSchool(id)"><i class="fa fa-times"></i></button>
                  </div>
                  <div v-if="!form.schools.ids.length" class="text-muted small p-50">{{ form.schools.mode == 'allow' ? 'لم تُضف مدارس بعد — لن يظهر سعود لأي مدرسة.' : 'لم تُضف مدارس بعد.' }}</div>
                </div>
                <div class="sd-school-search">
                  <input v-model="schoolSearch.q" type="search" class="form-control form-control-sm" placeholder="ابحث باسم المدرسة أو الجوال أو المدينة لإضافتها" aria-label="بحث عن مدرسة" @input="searchSchoolsLater()">
                  <div v-if="schoolSearch.loading" class="small text-muted mt-25"><i class="fa fa-spinner fa-spin"></i> جاري البحث...</div>
                  <div v-else-if="schoolSearch.error" class="small text-danger mt-25">{{ schoolSearch.error }}</div>
                  <div v-if="schoolSearch.results.length" class="sd-results">
                    <button v-for="x in schoolSearch.results" :key="x.id" type="button" class="sd-result" :disabled="form.schools.ids.indexOf(x.id) >= 0" @click="addSchool(x.id, x.name)">
                      <span><b>{{ x.name }}</b><small>{{ [x.location, x.phone].filter(Boolean).join(' · ') }}</small></span>
                      <i class="fa" :class="form.schools.ids.indexOf(x.id) >= 0 ? 'fa-check text-success' : 'fa-plus'"></i>
                    </button>
                  </div>
                  <div v-else-if="schoolSearch.q.trim().length >= 2 && !schoolSearch.loading && schoolSearch.done" class="small text-muted mt-25">لا توجد نتائج.</div>
                </div>
                <div class="sd-inline mt-50">
                  <input v-model.trim="schoolSearch.manual" dir="ltr" maxlength="24" class="form-control form-control-sm sd-grow" placeholder="أو رقم المدرسة (24 حرفاً)" aria-label="رقم المدرسة" @keydown.enter.prevent="addManualSchool()">
                  <button class="btn btn-sm btn-outline-primary" :disabled="!schoolSearch.manual" @click="addManualSchool()"><i class="fa fa-plus"></i> إضافة</button>
                </div>
              </template>
              <small v-else class="text-muted">يظهر سعود لكل حسابات المدارس ومشرفيها (ليس للمعلمين).</small>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================================================== تعليمات التنفيذ والقوالب -->
      <div v-show="tab == 'templates'">
        <div class="row">
          <div class="col-12 col-xl-6 g">
            <div class="card">
              <div class="card-header"><h5 class="mb-0"><i class="fa fa-cogs"></i> تعليمات التنفيذ (الملفات والصور والرسوم)</h5></div>
              <div class="card-body">
                <p class="text-muted small">
                  تُضاف إلى قواعدنا الثابتة عندما يطلب المستخدم Excel أو PDF أو صورة أو رسماً بيانياً. سعود لا يكتب البيانات بنفسه — يختار الجدول والأعمدة والترتيب والقالب،
                  والمتصفح يصنع الملف من بيانات الصفحة.
                </p>
                <textarea v-model="form.action_instructions" rows="7" maxlength="4000" class="form-control" :placeholder="actionPlaceholder"></textarea>
                <div class="sd-count-line"><small class="text-muted">{{ (form.action_instructions || '').length }} من 4000 حرف</small></div>
                <div class="sd-examples">
                  <span class="small text-muted">أضف مثالاً:</span>
                  <button v-for="e in actionExamples" :key="e" class="sd-ex" @click="addLine('action_instructions', e)"><i class="fa fa-plus"></i> {{ e }}</button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6 g">
            <div class="card">
              <div class="card-header"><h5 class="mb-0"><i class="fa fa-commenting-o"></i> تعليمات الإجابة (الأسلوب والقواعد)</h5></div>
              <div class="card-body">
                <p class="text-muted small">
                  أسلوب الردود والقواعد الإضافية للأسئلة. ثابت دائماً: ردود عربية قصيرة، لا يخترع أسعاراً، ولا يرى أسماء أو جوالات أو هويات الطلاب (تبقى في المتصفح).
                </p>
                <textarea v-model="form.extra_instructions" rows="7" maxlength="4000" class="form-control" :placeholder="extraPlaceholder"></textarea>
                <div class="sd-count-line"><small class="text-muted">{{ (form.extra_instructions || '').length }} من 4000 حرف</small></div>
                <div class="sd-examples">
                  <span class="small text-muted">أضف مثالاً:</span>
                  <button v-for="e in extraExamples" :key="e" class="sd-ex" @click="addLine('extra_instructions', e)"><i class="fa fa-plus"></i> {{ e }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-xl-5 g">
            <div class="card">
              <div class="card-header"><h5 class="mb-0"><i class="fa fa-paint-brush"></i> قالب الملفات (PDF والصور)</h5></div>
              <div class="card-body">
                <div class="form-group">
                  <label class="d-block">الشعار أعلى الملف</label>
                  <div class="sd-seg" role="radiogroup" aria-label="الشعار">
                    <label v-for="o in logoOptions" :key="o.value" :class="{ on: tpl.logo == o.value }">
                      <input v-model="tpl.logo" type="radio" name="sd-logo" :value="o.value">
                      <i :class="'fa ' + o.icon"></i> {{ o.text }}
                    </label>
                  </div>
                  <small class="text-muted">شعار المدرسة إن وُجد، وإلا شعار التحضير الذكي.</small>
                </div>
                <div class="row">
                  <div class="col-sm-6 form-group">
                    <label for="sd-primary">اللون الأساسي</label>
                    <div class="sd-color">
                      <input v-model="tpl.primary" type="color" aria-label="اختيار اللون الأساسي">
                      <input id="sd-primary" v-model.trim="tpl.primary" maxlength="7" dir="ltr" class="form-control form-control-sm" :class="{ 'is-invalid': !isHex(tpl.primary) }">
                    </div>
                    <div class="sd-swatches">
                      <button v-for="c in primarySwatches" :key="c" :style="{ background: c }" :class="{ on: low(tpl.primary) == low(c) }" :aria-label="c" @click="tpl.primary = c"></button>
                    </div>
                  </div>
                  <div class="col-sm-6 form-group">
                    <label for="sd-accent">لون التمييز</label>
                    <div class="sd-color">
                      <input v-model="tpl.accent" type="color" aria-label="اختيار لون التمييز">
                      <input id="sd-accent" v-model.trim="tpl.accent" maxlength="7" dir="ltr" class="form-control form-control-sm" :class="{ 'is-invalid': !isHex(tpl.accent) }">
                    </div>
                    <div class="sd-swatches">
                      <button v-for="c in accentSwatches" :key="c" :style="{ background: c }" :class="{ on: low(tpl.accent) == low(c) }" :aria-label="c" @click="tpl.accent = c"></button>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="d-block">حجم الورق</label>
                  <div class="sd-seg" role="radiogroup" aria-label="حجم الورق">
                    <label :class="{ on: tpl.paper == 'A4' }"><input v-model="tpl.paper" type="radio" name="sd-paper" value="A4"><i class="fa fa-file-o"></i> A4 طولي</label>
                    <label :class="{ on: tpl.paper == 'A4-landscape' }"><input v-model="tpl.paper" type="radio" name="sd-paper" value="A4-landscape"><i class="fa fa-file-o fa-rotate-90"></i> A4 عرضي</label>
                  </div>
                </div>
                <div class="form-group">
                  <label for="sd-header">سطر إضافي في الترويسة</label>
                  <input id="sd-header" v-model="tpl.header" maxlength="120" class="form-control" placeholder="مثال: إدارة شؤون الطلاب">
                </div>
                <div class="form-group">
                  <label for="sd-footer">التذييل</label>
                  <input id="sd-footer" v-model="tpl.footer" maxlength="120" class="form-control" placeholder="التحضير الذكي — tahdir.net">
                </div>
                <div class="form-group">
                  <label for="sd-fs">حجم الخط: <b>{{ tpl.font_size }}</b></label>
                  <input id="sd-fs" v-model.number="tpl.font_size" type="range" min="9" max="18" step="1" class="custom-range">
                  <div class="sd-range-ends"><small>9</small><small>18</small></div>
                </div>
                <div class="custom-control custom-switch">
                  <input id="sd-dates" v-model="tpl.show_dates" type="checkbox" class="custom-control-input">
                  <label class="custom-control-label" for="sd-dates">إظهار التاريخ الهجري والميلادي</label>
                </div>
                <button class="btn btn-sm btn-flat mt-1" @click="resetTemplates()"><i class="fa fa-undo"></i> القيم الافتراضية للقالب</button>
              </div>
            </div>
          </div>

          <div class="col-12 col-xl-7 g">
            <div class="card sd-preview-card">
              <div class="card-header sd-card-head">
                <h5 class="mb-0"><i class="fa fa-file-pdf-o"></i> معاينة مباشرة</h5>
                <small class="text-muted">مثال لصفحة PDF بهذا القالب · {{ tpl.paper == 'A4' ? 'A4 طولي' : 'A4 عرضي' }}</small>
              </div>
              <div class="card-body">
                <div ref="paperBox" class="sd-paper-box" :style="{ height: Math.round(paperSize.h * paperScale) + 'px' }">
                  <div class="sd-paper" :style="paperStyle">
                    <header class="sd-doc-head" :style="{ borderBottomColor: pPrimary }">
                      <div v-if="tpl.logo != 'none'" class="sd-doc-logo">
                        <app-logo v-if="tpl.logo == 'tahdir'" mark-only />
                        <span v-else class="sd-doc-school-logo" :style="{ borderColor: pPrimary, color: pPrimary }"><i class="fa fa-university"></i><small>شعار المدرسة</small></span>
                      </div>
                      <div class="sd-doc-titles">
                        <span class="sd-doc-org">المملكة العربية السعودية · وزارة التعليم</span>
                        <b class="sd-doc-school" :style="{ color: pPrimary }">مدرسة الأمل الابتدائية</b>
                        <span v-if="tpl.header" class="sd-doc-line">{{ tpl.header }}</span>
                      </div>
                      <div v-if="tpl.show_dates" class="sd-doc-dates">
                        <span>{{ hijriToday }}</span>
                        <span>{{ gregToday }}</span>
                      </div>
                    </header>
                    <h4 class="sd-doc-title" :style="{ color: pPrimary }">الطلاب الغائبون والمتأخرون — الفصل 3/أ</h4>
                    <div class="sd-doc-sub">حسب فلتر الصفحة: الفصل 3/أ · {{ todayIso }}</div>
                    <div class="sd-doc-cards">
                      <div v-for="c in sampleCards" :key="c.label" :style="{ borderTopColor: c.accent ? pAccent : pPrimary }">
                        <span>{{ c.label }}</span><b :style="{ color: c.accent ? pAccent : pPrimary }">{{ c.value }}</b>
                      </div>
                    </div>
                    <table class="sd-doc-table">
                      <thead>
                        <tr :style="{ background: pPrimary }">
                          <th>م</th><th>الاسم</th><th>الفصل</th><th>الحالة</th><th>وقت الحضور</th><th v-if="tpl.paper != 'A4'">الملاحظة</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(r, i) in sampleRows" :key="i" :style="i % 2 ? { background: rgba(pPrimary, 0.05) } : {}">
                          <td>{{ i + 1 }}</td>
                          <td>{{ r.name }}</td>
                          <td>{{ r.cls }}</td>
                          <td><span class="sd-doc-pill" :style="r.hl ? { background: rgba(pAccent, 0.18), color: pAccent } : { background: rgba(pPrimary, 0.1), color: pPrimary }">{{ r.status }}</span></td>
                          <td dir="ltr">{{ r.time }}</td>
                          <td v-if="tpl.paper != 'A4'">{{ r.note }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="sd-doc-note" :style="{ borderColor: pAccent, background: rgba(pAccent, 0.08) }">
                      <b :style="{ color: pAccent }">ملاحظة:</b> مُيّز الغياب بلون التمييز · عدد الصفوف 6 من 472
                    </div>
                    <footer class="sd-doc-foot" :style="{ borderTopColor: pPrimary }">
                      <span>{{ tpl.footer || ' ' }}</span>
                      <span>صفحة 1 من 1</span>
                    </footer>
                  </div>
                </div>
                <small class="text-muted d-block mt-50">المعاينة تقريبية؛ الملف الحقيقي يُصنع في متصفح المدرسة ببيانات الصفحة وشعار المدرسة الفعلي.</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================================================== تعليمات الصفحات (SAUD_SPEC F1 page_rules) -->
      <div v-show="tab == 'pages'" class="row">
        <div class="col-12 col-xl-8 g">
          <div class="card">
            <div class="card-header sd-card-head">
              <div>
                <h5 class="mb-0"><i class="fa fa-map-signs"></i> تعليمات الصفحات</h5>
                <small class="text-muted">تعليمات واختصارات وترحيب لصفحات معينة، أو إخفاء سعود فيها. تُرسل تعليمات الصفحة فقط عندما تكون المدرسة فيها.</small>
              </div>
              <button class="btn btn-sm btn-primary" @click="openRule(-1)"><i class="fa fa-plus"></i> قاعدة جديدة</button>
            </div>
            <draggable v-model="form.page_rules" handle=".sd-rule-drag" :animation="150" tag="div" class="sd-rules">
              <div v-for="(r, i) in form.page_rules" :key="r.id" class="sd-rule" :class="{ off: !r.enabled, hit: testerResult.win && testerResult.win.rule === r }">
                <span class="sd-rule-drag" title="اسحب لتغيير الترتيب" aria-hidden="true"><i class="fa fa-bars"></i></span>
                <div class="sd-rule-main" role="button" tabindex="0" @click="openRule(i)" @keydown.enter="openRule(i)">
                  <div class="sd-rule-title">
                    <b>{{ r.title || r.pattern }}</b>
                    <code dir="ltr" class="sd-route">{{ r.pattern }}</code>
                  </div>
                  <div class="sd-rule-badges">
                    <span v-if="isPrefix(r.pattern)" class="sd-badge"><i class="fa fa-sitemap"></i> كل الصفحات التي تبدأ بـ</span>
                    <span v-if="r.instructions" class="sd-badge ok"><i class="fa fa-file-text-o"></i> تعليمات</span>
                    <span v-if="r.welcome" class="sd-badge"><i class="fa fa-hand-paper-o"></i> ترحيب خاص</span>
                    <span v-if="r.quick_prompts.length" class="sd-badge"><i class="fa fa-bolt"></i> {{ r.quick_prompts.length }} اختصارات</span>
                    <span v-if="!r.allow_all_data" class="sd-badge warn">الصفحة الحالية فقط</span>
                    <span v-if="!r.enabled" class="sd-badge bad"><i class="fa fa-eye-slash"></i> سعود مخفي هنا</span>
                  </div>
                </div>
                <div class="custom-control custom-switch sd-rule-switch" :title="r.enabled ? 'سعود ظاهر في هذه الصفحة' : 'سعود مخفي في هذه الصفحة'">
                  <input :id="'rule-on-' + r.id" v-model="r.enabled" type="checkbox" class="custom-control-input">
                  <label class="custom-control-label" :for="'rule-on-' + r.id">{{ r.enabled ? 'ظاهر' : 'مخفي' }}</label>
                </div>
                <div class="sd-rule-tools">
                  <button class="btn btn-sm btn-flat" :disabled="i == 0" title="أعلى" :aria-label="'تحريك ' + (r.title || r.pattern) + ' لأعلى'" @click="moveRule(i, -1)"><i class="fa fa-arrow-up"></i></button>
                  <button class="btn btn-sm btn-flat" :disabled="i == form.page_rules.length - 1" title="أسفل" :aria-label="'تحريك ' + (r.title || r.pattern) + ' لأسفل'" @click="moveRule(i, 1)"><i class="fa fa-arrow-down"></i></button>
                  <button class="btn btn-sm btn-flat" title="تعديل" @click="openRule(i)"><i class="fa fa-pencil"></i></button>
                  <button class="btn btn-sm btn-flat text-danger" title="حذف" @click="deleteRule(i)"><i class="fa fa-trash"></i></button>
                </div>
              </div>
            </draggable>
            <div v-if="!form.page_rules.length" class="sd-empty sm in-card">
              <div class="sd-empty-icon"><i class="fa fa-map-signs"></i></div>
              <h6>لا توجد تعليمات لصفحات معينة</h6>
              <p>سعود يعمل في كل الصفحات بالإعدادات العامة. أضف قاعدة لتعطيه تعليمات خاصة بصفحة، أو لإخفائه منها.</p>
              <button class="btn btn-sm btn-primary" @click="openRule(-1)"><i class="fa fa-plus"></i> قاعدة جديدة</button>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-4 g">
          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-crosshairs"></i> جرّب مسار</h5></div>
            <div class="card-body">
              <label for="sd-tester" class="small">مسار صفحة في لوحة المدرسة</label>
              <input id="sd-tester" v-model="tester.route" dir="ltr" list="sd-routes-dl" class="form-control" placeholder="/_students/list" autocomplete="off">
              <div v-if="testerResult.route" class="sd-verdict-box">
                <div v-if="testerResult.title" class="small text-muted mb-50">{{ testerResult.title }}</div>
                <div class="sd-verdict" :class="testerResult.visible ? 'ok' : 'bad'">
                  <i class="fa" :class="testerResult.visible ? 'fa-eye' : 'fa-eye-slash'"></i>
                  {{ testerResult.visible ? 'سعود يظهر في هذه الصفحة' : 'سعود مخفي في هذه الصفحة' }}
                </div>
                <div v-if="testerResult.why" class="small text-muted mt-25">{{ testerResult.why }}</div>
                <div class="sd-win">
                  <span class="small text-muted">القاعدة المطبقة</span>
                  <button v-if="testerResult.win" class="sd-win-rule" @click="openRule(testerResult.win.index)">
                    <b>{{ testerResult.win.rule.title || testerResult.win.rule.pattern }}</b>
                    <code dir="ltr" class="sd-route">{{ testerResult.win.rule.pattern }}</code>
                    <small>{{ testerResult.win.exact ? 'مطابقة تامة' : 'تبدأ بـ ' + testerResult.win.rule.pattern.slice(0, -1) }}</small>
                  </button>
                  <div v-else class="small">لا تنطبق أي قاعدة — تُستخدم الإعدادات العامة.</div>
                </div>
                <dl v-if="testerResult.visible" class="sd-action-lines">
                  <dt>التعليمات</dt><dd>{{ testerResult.win && testerResult.win.rule.instructions ? 'تعليمات القاعدة + العامة' : 'العامة فقط' }}</dd>
                  <dt>الترحيب</dt><dd>{{ testerResult.win && testerResult.win.rule.welcome ? 'من القاعدة' : 'العام' }}</dd>
                  <dt>الاختصارات</dt><dd>{{ testerPrompts.join('، ') || '—' }}</dd>
                  <dt>كل البيانات</dt><dd>{{ !testerResult.win || testerResult.win.rule.allow_all_data ? 'مسموح' : 'الصفحة الحالية فقط' }}</dd>
                </dl>
                <div v-if="testerResult.others.length" class="sd-others">
                  <span class="small text-muted">تطابق أيضاً (أقل تحديداً):</span>
                  <button v-for="m in testerResult.others" :key="m.rule.id" class="sd-badge" @click="openRule(m.index)">{{ m.rule.title || m.rule.pattern }}</button>
                </div>
              </div>
              <datalist id="sd-routes-dl"><option v-for="r in routes" :key="r.path" :value="r.path">{{ r.title }}</option></datalist>
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <p class="sd-note mb-0">
                <b>كيف تُختار القاعدة؟</b> النمط مسار كامل مثل <code dir="ltr">/_students/list</code>، أو بداية مسار تنتهي بـ <code dir="ltr">*</code> مثل
                <code dir="ltr">/_students*</code> لكل صفحات الطلاب. تفوز القاعدة الأكثر تحديداً: المطابقة التامة، ثم بداية المسار الأطول.
                القاعدة الموقوفة تُخفي سعود في صفحاتها. لا يُسمح بنمطين متطابقين، والترتيب لتنظيم القائمة فقط.
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- ===================================================== الاستهلاك -->
      <div v-show="tab == 'usage'">
        <div class="card">
          <div class="card-body sd-filters">
            <div class="form-group">
              <label for="u-from">من</label>
              <input id="u-from" v-model="usage.from" type="date" class="form-control form-control-sm" @change="loadUsage()">
            </div>
            <div class="form-group">
              <label for="u-to">إلى</label>
              <input id="u-to" v-model="usage.to" type="date" class="form-control form-control-sm" @change="loadUsage()">
            </div>
            <div class="sd-tools sd-filter-tools">
              <div class="btn-group btn-group-sm" role="group" aria-label="فترات سريعة">
                <button v-for="r in ranges" :key="r.days" class="btn btn-outline-primary" :class="{ active: rangeIs(r.days) }" @click="setRange(r.days)">{{ r.text }}</button>
              </div>
              <button class="btn btn-sm btn-outline-primary" :disabled="usage.loading" aria-label="تحديث" @click="loadUsage()"><i class="fa fa-refresh" :class="{ 'fa-spin': usage.loading }"></i></button>
            </div>
          </div>
        </div>

        <div v-if="usage.missing" class="card sd-empty sm">
          <div class="sd-empty-icon"><i class="fa fa-bar-chart"></i></div>
          <h6>الاستهلاك غير متاح على هذا السيرفر بعد</h6>
          <p>بعد تحديث السيرفر ستظهر هنا الرسائل والتوكن والتكلفة لكل مدرسة ولكل يوم.</p>
        </div>
        <div v-else-if="!usage.data" class="card card-body text-center text-muted">
          <span v-if="usage.loading"><i class="fa fa-spinner fa-spin"></i> جاري التحميل...</span>
          <span v-else>لا توجد بيانات.</span>
        </div>
        <template v-else>
          <div class="sd-usage-card">
            <div class="sd-usage-main">
              <span class="sd-usage-label"><i class="fa fa-usd"></i> تكلفة الفترة</span>
              <b class="sd-usage-cost" dir="ltr">{{ usd(usage.data.totals.cost_usd, true) }}</b>
              <small>{{ usage.from || '…' }} ← {{ usage.to || '…' }} · متوسط <bdi dir="ltr">{{ usd(avgCost) }}</bdi> للرسالة</small>
            </div>
            <div class="sd-stat"><span>الرسائل</span><b>{{ num(usage.data.totals.messages) }}</b></div>
            <div class="sd-stat"><span>المدارس</span><b>{{ num(usage.data.totals.schools) }}</b></div>
            <div class="sd-stat"><span>التوكن</span><b dir="ltr">{{ compact(usage.data.totals.tokens) }}</b></div>
            <div class="sd-stat today"><span>رسائل اليوم</span><b>{{ num(usage.data.totals.today_messages) }}</b></div>
          </div>

          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0">الرسائل والتكلفة يومياً</h5>
              <small class="text-muted">بتوقيت الرياض</small>
            </div>
            <div class="card-body pt-0">
              <!-- dir=ltr: apexcharts lays out a second (opposite) axis wrongly inside the RTL page -->
              <div v-if="dayData.length" dir="ltr" class="sd-chart">
                <vue-apex-charts type="line" height="240" :options="dayOptions" :series="daySeries" />
              </div>
              <div v-else class="text-center text-muted small py-2">لا توجد رسائل في هذه الفترة.</div>
            </div>
          </div>

          <div class="card">
            <div class="card-header sd-card-head">
              <div>
                <h5 class="mb-0">المدارس</h5>
                <small class="text-muted">«اليوم» من الحد اليومي ({{ saved.daily_limit }}) · «إعادة تعيين حد اليوم» يسمح للمدرسة بإرسال رسائل جديدة اليوم.</small>
              </div>
              <input v-model="usage.q" type="search" class="form-control form-control-sm sd-search" placeholder="ابحث باسم المدرسة أو رقمها" aria-label="بحث في المدارس">
            </div>
            <div class="table-responsive">
              <table class="table sd-table mb-0">
                <thead>
                  <tr>
                    <th v-for="c in schoolCols" :key="c.key">
                      <button class="sd-sort" :class="{ on: usage.sort.key == c.key }" @click="sortBy(c.key)">
                        {{ c.text }} <i class="fa" :class="sortIcon(c.key)"></i>
                      </button>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in schoolRowsShown" :key="r.school_id">
                    <td>
                      <b>{{ r.name || '—' }}</b>
                      <div class="small text-muted" dir="ltr" style="text-align:right">{{ r.school_id }}</div>
                    </td>
                    <td class="sd-nowrap">
                      <div class="sd-today"><b>{{ num(r.today) }}</b> من {{ saved.daily_limit }}</div>
                      <div class="sd-bar" :title="pct(r.today) + '%'"><span :class="{ full: r.today >= saved.daily_limit }" :style="{ width: pct(r.today) + '%' }"></span></div>
                    </td>
                    <td class="sd-nowrap">{{ num(r.messages) }}</td>
                    <td class="sd-nowrap" dir="ltr" style="text-align:right">{{ num(r.tokens) }}</td>
                    <td class="sd-nowrap"><b dir="ltr">{{ usd(r.cost_usd) }}</b></td>
                    <td class="sd-nowrap small">{{ r.last_at ? ago(r.last_at) : '—' }}</td>
                    <td class="text-left sd-nowrap">
                      <button class="btn btn-sm btn-outline-primary" :disabled="!r.today || resetting == r.school_id" :title="r.today ? '' : 'لم ترسل المدرسة رسائل اليوم'" @click="resetToday(r)">
                        <i class="fa" :class="resetting == r.school_id ? 'fa-spinner fa-spin' : 'fa-undo'"></i> إعادة تعيين حد اليوم
                      </button>
                    </td>
                  </tr>
                  <tr v-if="!schoolRows.length"><td colspan="7" class="text-center text-muted">{{ usage.q ? 'لا توجد مدرسة بهذا البحث.' : 'لم تستخدم أي مدرسة سعود في هذه الفترة.' }}</td></tr>
                </tbody>
              </table>
            </div>
            <div v-if="schoolRows.length > usage.show" class="card-footer text-center">
              <button class="btn btn-sm btn-outline-secondary" @click="usage.show += 50">عرض المزيد ({{ schoolRows.length - usage.show }})</button>
            </div>
          </div>
        </template>
      </div>

      <!-- ===================================================== المحادثات -->
      <div v-show="tab == 'logs'">
        <div class="card">
          <div class="card-body sd-filters">
            <div class="form-group">
              <label for="l-school">المدرسة</label>
              <select id="l-school" v-model="logs.school_id" class="form-control form-control-sm" @change="reloadLogs()">
                <option value="">كل المدارس</option>
                <option value="admin-test">تجربة الإدارة</option>
                <option v-for="s in schoolOptions" :key="s.id" :value="s.id">{{ s.name }}</option>
              </select>
            </div>
            <div class="form-group sd-grow">
              <label for="l-q">بحث في النص</label>
              <input id="l-q" v-model="logs.q" type="search" class="form-control form-control-sm" placeholder="ابحث في الأسئلة والردود" @input="searchLater()">
            </div>
            <div class="sd-tools sd-filter-tools">
              <button class="btn btn-sm btn-outline-secondary" @click="resetLogFilters()"><i class="fa fa-times"></i> مسح</button>
              <button class="btn btn-sm btn-outline-primary" :disabled="logs.loading" aria-label="تحديث" @click="loadLogs()"><i class="fa fa-refresh" :class="{ 'fa-spin': logs.loading }"></i></button>
            </div>
          </div>
          <div v-if="logs.missing" class="sd-empty sm in-card">
            <div class="sd-empty-icon"><i class="fa fa-comments-o"></i></div>
            <h6>سجل المحادثات غير متاح على هذا السيرفر بعد</h6>
            <p>بعد تحديث السيرفر ستظهر هنا أسئلة المدارس وردود سعود والإجراءات وتكلفة كل رسالة.</p>
          </div>
          <template v-else>
            <div class="table-responsive">
              <table class="table sd-table sd-log mb-0">
                <thead>
                  <tr>
                    <th>التاريخ والوقت</th>
                    <th>المدرسة</th>
                    <th>الصفحة</th>
                    <th>السؤال</th>
                    <th>الإجراءات</th>
                    <th>التكلفة</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in logs.rows" :key="r._id || r.id" class="sd-click" @click="openLog(r)">
                    <td class="sd-nowrap" dir="ltr" style="text-align:right">{{ when(r.at || r.created_at) }}</td>
                    <td>
                      <b>{{ schoolName(r) }}</b>
                      <div v-if="r.user_name" class="small text-muted">{{ r.user_name }}</div>
                    </td>
                    <td><code dir="ltr" class="sd-route">{{ r.route || '—' }}</code></td>
                    <td><div class="sd-clamp">{{ r.message }}</div></td>
                    <td>
                      <span v-for="(t, i) in actionTypes(r.actions)" :key="i" class="sd-act" :class="actMeta(t).cls"><i class="fa" :class="actMeta(t).icon"></i> {{ actMeta(t).short }}</span>
                      <span v-if="r.screenshot" class="sd-act shot" title="مع لقطة من الصفحة"><i class="fa fa-camera"></i></span>
                      <span v-if="r.error" class="sd-act err" :title="r.error"><i class="fa fa-exclamation-triangle"></i> خطأ</span>
                      <span v-if="!actionTypes(r.actions).length && !r.error && !r.screenshot" class="text-muted small">نص فقط</span>
                      <!-- the files the school's browser built from this answer (and, for older answers, the saved design) -->
                      <div v-if="(r.files || []).length || rowDesign(r)" class="sd-rfiles" @click.stop>
                        <i class="fa fa-paperclip sd-rfiles-ic" title="الملفات المُنشأة"></i>
                        <template v-for="f in sortedFiles(r)">
                          <button v-if="f.kind == 'image'" :key="'f' + f.i" type="button" class="sd-rthumb" :title="f.name" :aria-label="'عرض ' + f.name" @click="viewFile(r, f)">
                            <img v-if="fileUrl(r, f)" :src="fileUrl(r, f)" alt="">
                            <i v-else class="fa" :class="fileBusy(r, f) ? 'fa-spinner fa-spin' : 'fa-picture-o'"></i>
                          </button>
                          <button v-else :key="'f' + f.i" type="button" class="sd-rfile" :class="f.kind" :title="f.name" @click="f.kind == 'excel' ? downloadFile(r, f) : viewFile(r, f)">
                            <i class="fa" :class="fileIcon(f)"></i> {{ fileKind(f) }}<i v-if="f.kind == 'excel'" class="fa fa-download sd-rfile-dl"></i>
                          </button>
                        </template>
                        <button v-if="rowDesign(r)" type="button" class="sd-rfile design" title="نسخة معاد بناؤها من التصميم المحفوظ" @click="previewRowDesign(r)"><i class="fa fa-eye"></i> معاينة التصميم</button>
                      </div>
                    </td>
                    <td class="sd-nowrap">
                      <b dir="ltr">{{ usd(r.cost_usd) }}</b>
                      <div v-if="tokTotal(r.tokens)" class="small text-muted">{{ num(tokTotal(r.tokens)) }} توكن</div>
                    </td>
                    <td class="sd-nowrap"><button class="btn btn-sm btn-outline-primary" @click.stop="openLog(r)"><i class="fa fa-file-text-o"></i> التفاصيل</button></td>
                  </tr>
                  <tr v-if="!logs.rows.length && !logs.loading"><td colspan="7" class="text-center text-muted">{{ logs.q || logs.school_id ? 'لا توجد محادثات بهذه الفلاتر.' : 'لا توجد محادثات بعد.' }}</td></tr>
                  <tr v-if="!logs.rows.length && logs.loading"><td colspan="7" class="text-center text-muted"><i class="fa fa-spinner fa-spin"></i> جاري التحميل...</td></tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer sd-pager">
              <small class="text-muted">{{ num(logs.total) }} رسالة · تُحذف السجلات الأقدم من 90 يوماً تلقائياً.</small>
              <div class="sd-tools">
                <button class="btn btn-sm btn-outline-secondary" :disabled="logs.page <= 0 || logs.loading" @click="logPage(-1)">السابق</button>
                <span class="small">صفحة {{ logs.page + 1 }} من {{ logPages }}</span>
                <button class="btn btn-sm btn-outline-secondary" :disabled="logs.page + 1 >= logPages || logs.loading" @click="logPage(1)">التالي</button>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- ===================================================== تجربة -->
      <div v-show="tab == 'test'" class="row">
        <div class="col-12 col-xl-5 g">
          <div class="card">
            <div class="card-header"><h5 class="mb-0"><i class="fa fa-flask"></i> اسأل سعود</h5></div>
            <div class="card-body">
              <div class="form-group">
                <label for="t-msg">الرسالة</label>
                <textarea id="t-msg" v-model="test.message" rows="3" maxlength="1000" class="form-control" placeholder="مثال: صدّر جدول الغائبين إلى Excel مرتبين حسب الفصل" @keydown.ctrl.enter="sendTest()" @keydown.meta.enter="sendTest()"></textarea>
                <div class="sd-chips sm mt-50">
                  <button v-for="(q, i) in testPrompts" :key="i" class="sd-ex" @click="test.message = q">{{ q }}</button>
                </div>
              </div>
              <div class="form-group">
                <label for="t-route">مسار الصفحة <small class="text-muted">— لتجربة «تعليمات الصفحات»</small></label>
                <input id="t-route" v-model.trim="test.route" dir="ltr" list="sd-routes-dl" class="form-control" placeholder="/_students/list" autocomplete="off" @input="syncTestRoute()">
                <div v-if="test.route" class="sd-test-rule">
                  <template v-if="testRule.win">
                    <span class="sd-badge" :class="testRule.win.rule.enabled ? 'ok' : 'bad'"><i class="fa" :class="testRule.win.rule.enabled ? 'fa-map-signs' : 'fa-eye-slash'"></i> {{ testRule.win.rule.title || testRule.win.rule.pattern }}</span>
                    <small class="text-muted">{{ testRule.win.rule.enabled ? (testRule.win.rule.instructions ? 'تعليمات هذه القاعدة تُرسل مع الرسالة.' : 'قاعدة بلا تعليمات.') : 'سعود مخفي في هذه الصفحة للمدارس — التجربة تعمل للإدارة.' }}</small>
                  </template>
                  <small v-else class="text-muted">لا تنطبق أي قاعدة صفحة — الإعدادات العامة.</small>
                </div>
              </div>
              <div v-if="dirty" class="alert alert-warning p-50 small mb-1"><i class="fa fa-exclamation-triangle"></i> التجربة تستخدم الإعدادات المحفوظة على السيرفر — احفظ التغييرات أولاً لتجربتها.</div>
              <div class="form-group mb-50">
                <div class="sd-card-head mb-25">
                  <label for="t-page" class="mb-0">لقطة الصفحة (PageSnapshot)</label>
                  <div class="sd-tools">
                    <button class="btn btn-sm btn-flat" :disabled="!!pageError" @click="formatPage()"><i class="fa fa-indent"></i> تنسيق</button>
                    <button class="btn btn-sm btn-flat" @click="test.page = samplePage()"><i class="fa fa-undo"></i> المثال</button>
                  </div>
                </div>
                <textarea id="t-page" v-model="test.page" rows="14" dir="ltr" spellcheck="false" class="form-control sd-code" :class="{ 'is-invalid': pageError }"></textarea>
                <small v-if="pageError" class="text-danger d-block">{{ pageError }}</small>
                <small v-else class="text-muted d-block">
                  ما تبنيه لوحة المدرسة من الصفحة المفتوحة: العنوان والفلاتر والبطاقات والجداول (أسماء الأعمدة وإحصاءاتها فقط — بدون أسماء الطلاب أو أرقامهم).
                  الحجم {{ pageBytes }} بايت من 8192.
                </small>
              </div>
              <div class="sd-tools">
                <button class="btn btn-primary" :disabled="test.sending || !test.message.trim() || !!pageError" @click="sendTest()">
                  <i class="fa" :class="test.sending ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i> إرسال إلى سعود
                </button>
                <small class="text-muted">لا تُحسب من حد أي مدرسة، وتُسجَّل في «المحادثات» باسم «تجربة الإدارة».</small>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-xl-7 g">
          <div class="card">
            <div class="card-header sd-card-head">
              <h5 class="mb-0"><i class="fa fa-comments-o"></i> الرد</h5>
              <button v-if="test.results.length" class="btn btn-sm btn-flat" @click="test.results = []"><i class="fa fa-trash"></i> مسح</button>
            </div>
            <div class="card-body">
              <div v-if="test.missing" class="sd-empty sm in-card">
                <div class="sd-empty-icon"><i class="fa fa-flask"></i></div>
                <h6>التجربة غير متاحة على هذا السيرفر بعد</h6>
                <p>بعد تحديث السيرفر يمكنك سؤال سعود من هنا ورؤية رده والإجراءات.</p>
              </div>
              <div v-else-if="!test.results.length && !test.sending" class="sd-empty sm in-card">
                <div class="sd-empty-icon"><span class="sd-mark lg">س</span></div>
                <h6>جرّب سعود قبل المدارس</h6>
                <p>اكتب سؤالاً أو طلب ملف، وعدّل لقطة الصفحة إن أردت، ثم اضغط «إرسال إلى سعود» لترى الرد والإجراءات التي ستظهر للمدرسة.</p>
              </div>
              <div v-if="test.sending" class="sd-thread">
                <div class="sd-bubble me">{{ test.pending }}</div>
                <div class="sd-bubble saud sd-typing"><span></span><span></span><span></span></div>
              </div>
              <div v-for="(x, i) in test.results" :key="x.id" class="sd-thread" :class="{ old: i > 0 }">
                <div class="sd-bubble me">{{ x.message }}</div>
                <div v-if="x.error" class="alert alert-danger p-1 mb-0">{{ x.error }}</div>
                <template v-else>
                  <div v-if="x.res.text" class="sd-bubble saud">{{ x.res.text }}</div>
                  <div v-for="(a, j) in x.res.actions || []" :key="j" class="sd-action" :class="actMeta(a.type).cls">
                    <div class="sd-action-head">
                      <i class="fa" :class="actMeta(a.type).icon"></i>
                      <div>
                        <b>{{ actionTitle(a) }}</b>
                        <small v-if="a.subtitle">{{ a.subtitle }}</small>
                      </div>
                      <span class="sd-action-btn" title="يعمل في لوحة المدرسة">{{ actMeta(a.type).button }}</span>
                    </div>
                    <dl class="sd-action-lines">
                      <template v-for="(l, k) in actionLines(a, x.snapshot)">
                        <dt :key="'t' + k">{{ l[0] }}</dt>
                        <dd :key="'d' + k">{{ l[1] }}</dd>
                      </template>
                    </dl>
                  </div>
                  <div class="sd-meta">
                    <span><i class="fa fa-clock-o"></i> {{ (x.ms / 1000).toFixed(1) }} ث</span>
                    <span v-if="x.res.model" dir="ltr">{{ x.res.model }}</span>
                    <span v-if="tokTotal(x.res.tokens)">{{ num(tokTotal(x.res.tokens)) }} توكن</span>
                    <span v-if="x.res.cost_usd != null" dir="ltr">{{ usd(x.res.cost_usd) }}</span>
                    <span v-if="x.route"><i class="fa fa-map-signs"></i> <bdi dir="ltr">{{ x.route }}</bdi> · {{ serverRule(x) }}</span>
                    <button class="btn btn-sm btn-flat" @click="x.raw = !x.raw"><i class="fa fa-code"></i> {{ x.raw ? 'إخفاء' : 'عرض' }} JSON</button>
                  </div>
                  <pre v-if="x.raw" class="sd-json" dir="ltr">{{ pretty(x.res) }}</pre>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- unsaved settings: one bar for every tab (settings, options, templates, page rules) -->
    <div v-if="state == 'ready' && dirty" class="sd-savebar" role="region" aria-label="حفظ التغييرات">
      <span><i class="fa fa-pencil"></i> لديك تغييرات لم تُحفظ<small v-if="dirtyTabs.length" class="sd-savebar-where"> · {{ dirtyTabs.join('، ') }}</small></span>
      <div class="sd-tools">
        <button class="btn btn-sm btn-outline-secondary" :disabled="saving" @click="revert()">تراجع</button>
        <button class="btn btn-sm btn-primary" :disabled="saving" @click="save()"><i class="fa" :class="saving ? 'fa-spinner fa-spin' : 'fa-check'"></i> حفظ التغييرات</button>
      </div>
    </div>

    <!-- one conversation: question, answer, actions JSON, tokens -->
    <div v-if="detail.open" class="sd-drawer-bg" @click="detail.open = false"></div>
    <aside class="sd-drawer" :class="{ open: detail.open }" aria-label="تفاصيل المحادثة">
      <div class="sd-drawer-head">
        <div>
          <b>تفاصيل المحادثة</b>
          <div class="small text-muted">{{ detail.row ? schoolName(detail.row) + ' · ' + when(detail.row.at || detail.row.created_at) : '' }}</div>
        </div>
        <button class="btn btn-sm btn-flat" aria-label="إغلاق" @click="detail.open = false"><i class="fa fa-times"></i></button>
      </div>
      <div class="sd-drawer-body">
        <div v-if="detail.loading" class="text-muted"><i class="fa fa-spinner fa-spin"></i> جاري التحميل...</div>
        <template v-else-if="detail.log">
          <div class="sd-kvs">
            <div><span>المستخدم</span><b>{{ detail.log.user_name || '—' }}</b></div>
            <div><span>الصفحة</span><code dir="ltr" class="sd-route">{{ detail.log.route || '—' }}</code></div>
            <div><span>النموذج</span><b dir="ltr">{{ detail.log.model || '—' }}</b></div>
            <div><span>لقطة من الصفحة</span><b>{{ detail.log.screenshot ? 'نعم' : 'لا' }}</b></div>
          </div>
          <div v-if="detail.log.error" class="alert alert-danger p-1 mt-1 mb-0"><b>خطأ:</b> {{ detail.log.error }}</div>

          <h6 class="sd-sec"><i class="fa fa-question-circle-o"></i> السؤال</h6>
          <div class="sd-bubble me wide">{{ detail.log.message || '—' }}</div>
          <h6 class="sd-sec"><i class="fa fa-comment-o"></i> الرد</h6>
          <div class="sd-bubble saud wide">{{ detail.log.reply || '—' }}</div>

          <template v-if="(detail.log.files || []).length || detailPreviews.length">
            <h6 class="sd-sec"><i class="fa fa-paperclip"></i> الملفات المُنشأة <span class="sd-count">{{ (detail.log.files || []).length }}</span></h6>
            <div class="sd-files">
              <div v-for="f in sortedFiles(detail.log)" :key="'f' + f.i" class="sd-file" :class="f.kind">
                <button v-if="f.kind == 'image'" type="button" class="sd-file-thumb" :aria-label="'عرض ' + f.name" @click="viewFile(detail.log, f)">
                  <img v-if="fileUrl(detail.log, f)" :src="fileUrl(detail.log, f)" alt="">
                  <i v-else class="fa" :class="fileBusy(detail.log, f) ? 'fa-spinner fa-spin' : 'fa-picture-o'"></i>
                </button>
                <div v-else class="sd-file-icon"><i class="fa" :class="fileIcon(f)"></i></div>
                <div class="sd-file-body">
                  <b :title="f.name">{{ f.name }}</b>
                  <small>{{ fileKind(f) }} · <bdi dir="ltr">{{ fileSize(f.size) }}</bdi><template v-if="actionOf(f)"> · من «{{ actionTitle(actionOf(f)) }}»</template></small>
                  <div class="sd-file-btns">
                    <button v-if="f.kind != 'excel'" class="btn btn-sm btn-outline-primary" @click="viewFile(detail.log, f)"><i class="fa fa-eye"></i> عرض</button>
                    <button class="btn btn-sm btn-outline-secondary" @click="downloadFile(detail.log, f)"><i class="fa fa-download"></i> تحميل</button>
                  </div>
                </div>
              </div>
              <!-- no uploaded file for this design / chart (an older answer, or never built): what the log keeps -->
              <div v-for="p in detailPreviews" :key="'p' + p.j" class="sd-file" :class="p.a.type">
                <template v-if="p.a.type == 'design'">
                  <div class="sd-file-icon"><i class="fa fa-paint-brush"></i></div>
                  <div class="sd-file-body">
                    <b>{{ actionTitle(p.a) }}</b>
                    <small>تصميم ({{ p.a.format == 'pdf' ? 'PDF' : 'صورة' }}) · لم يُرفع ملفه</small>
                    <div class="sd-file-btns">
                      <button class="btn btn-sm btn-outline-primary" @click="openDesign(detail.log, p.a)"><i class="fa fa-eye"></i> معاينة التصميم</button>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="sd-file-chart" dir="ltr" aria-hidden="true">
                    <vue-apex-charts :type="p.skel.type" height="78" width="112" :options="p.skel.options" :series="p.skel.series" />
                  </div>
                  <div class="sd-file-body">
                    <b>{{ actionTitle(p.a) }}</b>
                    <small>{{ chartSpec(p.a) }}</small>
                    <small class="sd-file-note">شكل الرسم فقط — القيم تُحسب في متصفح المدرسة ولا تُحفظ في السجل.</small>
                  </div>
                </template>
              </div>
            </div>
            <small class="text-muted d-block mt-50">نسخ مما أنشأه متصفح المدرسة من هذا الرد، تُحذف مع السجل بعد 90 يوماً.</small>
          </template>

          <h6 class="sd-sec"><i class="fa fa-bolt"></i> الإجراءات <span class="sd-count">{{ detailActions.length }}</span></h6>
          <template v-for="(a, j) in detailActions">
            <div v-if="a && typeof a == 'object'" :key="j" class="sd-action sm" :class="actMeta(a.type).cls">
              <div class="sd-action-head">
                <i class="fa" :class="actMeta(a.type).icon"></i>
                <div><b>{{ actionTitle(a) }}</b></div>
                <span class="sd-action-btn">{{ actMeta(a.type).button }}</span>
              </div>
            </div>
          </template>
          <pre v-if="detailActions.length" class="sd-json" dir="ltr">{{ pretty(detailActions) }}</pre>
          <div v-else class="text-muted small">رد نصي فقط، بلا إجراءات.</div>

          <h6 class="sd-sec"><i class="fa fa-usd"></i> التوكن والتكلفة</h6>
          <div class="sd-usage">
            <div><span>إدخال</span><b dir="ltr">{{ num(tok(detail.log, 'input')) }}</b></div>
            <div><span>مخزّن مؤقتاً</span><b dir="ltr">{{ num(tok(detail.log, 'cached')) }}</b></div>
            <div><span>إخراج</span><b dir="ltr">{{ num(tok(detail.log, 'output')) }}</b></div>
            <div><span>تفكير</span><b dir="ltr">{{ num(tok(detail.log, 'thoughts')) }}</b></div>
            <div class="sd-usage-total">
              <span>الإجمالي{{ detail.log.model ? ' · ' + detail.log.model : '' }}</span>
              <b>{{ num(tokTotal(detail.log.tokens)) }} توكن · <bdi dir="ltr">{{ usd(detail.log.cost_usd) }}</bdi></b>
            </div>
          </div>

          <template v-if="detail.log.page">
            <h6 class="sd-sec"><i class="fa fa-file-code-o"></i> لقطة الصفحة المرسلة</h6>
            <pre class="sd-json" dir="ltr">{{ pretty(parseMaybe(detail.log.page)) }}</pre>
          </template>
        </template>
      </div>
    </aside>

    <!-- one page rule (SAUD_SPEC F1): route picker or custom pattern, show / hide, instructions, prompts, welcome, all data -->
    <div v-if="ruleEd.open" class="sd-drawer-bg" @click="closeRule()"></div>
    <aside class="sd-drawer sd-rule-drawer" :class="{ open: ruleEd.open }" :aria-label="ruleEd.index >= 0 ? 'تعديل قاعدة الصفحة' : 'قاعدة صفحة جديدة'">
      <div class="sd-drawer-head">
        <div>
          <b>{{ ruleEd.index >= 0 ? 'تعديل قاعدة الصفحة' : 'قاعدة صفحة جديدة' }}</b>
          <div class="small text-muted">تُطبَّق بعد «حفظ التغييرات»</div>
        </div>
        <button class="btn btn-sm btn-flat" aria-label="إغلاق" @click="closeRule()"><i class="fa fa-times"></i></button>
      </div>
      <div v-if="ruleEd.open" class="sd-drawer-body">
        <h6 class="sd-sec mt-0"><i class="fa fa-map-marker"></i> الصفحة</h6>
        <div class="sd-seg mb-1" role="radiogroup" aria-label="طريقة اختيار الصفحة">
          <label :class="{ on: ruleEd.mode == 'pick' }"><input v-model="ruleEd.mode" type="radio" name="sd-rmode" value="pick"><i class="fa fa-list"></i> من صفحات المدرسة</label>
          <label :class="{ on: ruleEd.mode == 'custom' }"><input v-model="ruleEd.mode" type="radio" name="sd-rmode" value="custom"><i class="fa fa-code"></i> نمط مخصص</label>
        </div>

        <template v-if="ruleEd.mode == 'pick'">
          <input v-model="ruleEd.q" type="search" class="form-control form-control-sm" placeholder="ابحث باسم الصفحة أو مسارها" aria-label="بحث في الصفحات">
          <div class="sd-picker" role="listbox" aria-label="صفحات المدرسة">
            <button v-for="x in pickerRoutes" :key="x.path" type="button" role="option" class="sd-pick" :class="{ on: ruleEd.pick == x.path }" :aria-selected="ruleEd.pick == x.path ? 'true' : 'false'" @click="pickRoute(x)">
              <span>{{ x.title }}</span>
              <code dir="ltr">{{ x.path }}</code>
            </button>
            <div v-if="!routes.length" class="small text-muted p-1">لم يُرسل السيرفر قائمة الصفحات — استخدم «نمط مخصص».</div>
            <div v-else-if="!pickerRoutes.length" class="small text-muted p-1">لا توجد صفحة بهذا البحث.</div>
          </div>
          <div class="custom-control custom-switch mt-50">
            <input id="sd-rprefix" type="checkbox" class="custom-control-input" :checked="isPrefix(ruleEd.r.pattern)" :disabled="!ruleEd.pick || pickHasParams" @change="setPrefix($event.target.checked)">
            <label class="custom-control-label" for="sd-rprefix">وكل الصفحات التي تبدأ بهذا المسار</label>
          </div>
          <small v-if="pickHasParams" class="text-muted d-block sd-switch-help">مسار برقم متغير (مثل صفحة طالب) — يُطبَّق على كل الصفحات التي تبدأ به.</small>
        </template>
        <div v-else class="form-group mb-50">
          <label for="sd-rpattern" class="small mb-25">النمط</label>
          <input id="sd-rpattern" v-model.trim="ruleEd.r.pattern" dir="ltr" maxlength="200" class="form-control" placeholder="/_students*" autocomplete="off">
          <small class="text-muted">مسار كامل، أو أنهِه بـ <code dir="ltr">*</code> لـ«كل الصفحات التي تبدأ بـ».</small>
        </div>

        <div class="sd-covers">
          <span class="small">النمط: <code dir="ltr" class="sd-route">{{ ruleEd.r.pattern || '—' }}</code></span>
          <span v-if="ruleEd.r.pattern" class="small text-muted">
            {{ isPrefix(ruleEd.r.pattern) ? 'كل الصفحات التي تبدأ بـ ' + ruleEd.r.pattern.slice(0, -1) : 'هذه الصفحة فقط' }}
            <template v-if="routes.length"> · يطابق {{ ruleCovers.length }} من صفحات القائمة</template>
          </span>
        </div>

        <div class="form-group mt-1">
          <label for="sd-rtitle" class="small mb-25">اسم القاعدة</label>
          <input id="sd-rtitle" v-model="ruleEd.r.title" maxlength="80" class="form-control" placeholder="مثل: استعراض الطلاب">
        </div>

        <div class="sd-rule-show" :class="{ off: !ruleEd.r.enabled }">
          <div class="custom-control custom-switch">
            <input id="sd-renabled" v-model="ruleEd.r.enabled" type="checkbox" class="custom-control-input">
            <label class="custom-control-label" for="sd-renabled">إظهار سعود في هذه الصفحة</label>
          </div>
          <small>{{ ruleEd.r.enabled ? 'سعود ظاهر هنا بالتعليمات والاختصارات أدناه.' : 'سعود مخفي في هذه الصفحة (والإعدادات أدناه لا تُستخدم).' }}</small>
        </div>

        <div :class="{ 'sd-dim': !ruleEd.r.enabled }">
          <h6 class="sd-sec"><i class="fa fa-file-text-o"></i> تعليمات هذه الصفحة</h6>
          <textarea v-model="ruleEd.r.instructions" rows="5" maxlength="2000" class="form-control" :placeholder="rulePlaceholder"></textarea>
          <div class="sd-count-line"><small class="text-muted">{{ ruleEd.r.instructions.length }} من 2000 حرف</small></div>
          <div class="sd-examples">
            <span class="small text-muted">أضف مثالاً:</span>
            <button v-for="e in ruleExamples" :key="e" class="sd-ex" @click="addRuleLine(e)"><i class="fa fa-plus"></i> {{ e }}</button>
          </div>

          <h6 class="sd-sec"><i class="fa fa-bolt"></i> اختصارات هذه الصفحة</h6>
          <div class="sd-chips">
            <span v-for="(q, i) in ruleEd.r.quick_prompts" :key="i + q" class="sd-chip">
              <span class="sd-chip-text">{{ q }}</span>
              <button class="sd-chip-x" :aria-label="'حذف ' + q" @click="ruleEd.r.quick_prompts.splice(i, 1)"><i class="fa fa-times"></i></button>
            </span>
            <span v-if="!ruleEd.r.quick_prompts.length" class="text-muted small">فارغة = الاختصارات العامة ({{ form.quick_prompts.length }}).</span>
          </div>
          <div class="sd-inline mt-50">
            <input v-model="ruleEd.prompt" maxlength="80" class="form-control form-control-sm sd-grow" placeholder="مثل: صدّر الطلاب الغائبين Excel" :disabled="ruleEd.r.quick_prompts.length >= 8" @keydown.enter.prevent="addRulePrompt()">
            <button class="btn btn-sm btn-outline-primary" :disabled="!ruleEd.prompt.trim() || ruleEd.r.quick_prompts.length >= 8" @click="addRulePrompt()"><i class="fa fa-plus"></i> إضافة</button>
          </div>

          <h6 class="sd-sec"><i class="fa fa-hand-paper-o"></i> رسالة الترحيب في هذه الصفحة</h6>
          <textarea v-model="ruleEd.r.welcome" rows="2" maxlength="600" class="form-control" placeholder="فارغة = الترحيب العام"></textarea>

          <div class="sd-rule-show mt-1">
            <div class="custom-control custom-switch">
              <input id="sd-rall" v-model="ruleEd.r.allow_all_data" type="checkbox" class="custom-control-input">
              <label class="custom-control-label" for="sd-rall">السماح بتصدير كل البيانات</label>
            </div>
            <small>{{ ruleEd.r.allow_all_data ? 'عندما يكون في الجدول صفحات أخرى، تظهر للمستخدم «الصفحة الحالية» أو «كل البيانات».' : 'الملفات من الصفوف الظاهرة في الصفحة فقط.' }}</small>
          </div>
        </div>
        <div v-if="ruleEd.error" class="alert alert-danger p-1 mt-1 mb-0">{{ ruleEd.error }}</div>
      </div>
      <div class="sd-drawer-foot">
        <button v-if="ruleEd.index >= 0" class="btn btn-sm btn-outline-danger sd-foot-start" @click="deleteRule(ruleEd.index, true)"><i class="fa fa-trash"></i> حذف</button>
        <button class="btn btn-sm btn-outline-secondary" @click="closeRule()">إلغاء</button>
        <button class="btn btn-sm btn-primary" @click="applyRule()"><i class="fa fa-check"></i> {{ ruleEd.index >= 0 ? 'تطبيق' : 'إضافة القاعدة' }}</button>
      </div>
    </aside>

    <!-- a conversation file (image full size / PDF viewer) or the rebuilt design (sandboxed, no scripts) -->
    <b-modal v-model="viewer.show" :title="viewer.title" size="xl" centered modal-class="sd-viewer" @hidden="closeViewer()">
      <div v-if="viewer.loading" class="sd-viewer-msg"><i class="fa fa-spinner fa-spin"></i> جاري تحميل الملف...</div>
      <div v-else-if="viewer.error" class="sd-viewer-msg text-danger"><i class="fa fa-exclamation-triangle"></i> {{ viewer.error }}</div>
      <template v-else-if="viewer.kind == 'design'">
        <div class="sd-note mb-1"><i class="fa fa-info-circle"></i> نسخة معاد بناؤها من التصميم المحفوظ — قيم الصفوف لا تُحفظ في السجل، وتظهر مكانها أسماء الأعمدة.</div>
        <iframe class="sd-viewer-frame" sandbox="" referrerpolicy="no-referrer" :srcdoc="viewer.html" title="معاينة التصميم"></iframe>
      </template>
      <div v-else-if="viewer.kind == 'image'" class="sd-viewer-img"><img :src="viewer.url" :alt="viewer.title"></div>
      <iframe v-else-if="viewer.kind == 'pdf'" class="sd-viewer-frame" :src="viewer.url" :title="viewer.title"></iframe>
      <template #modal-footer>
        <small class="text-muted sd-viewer-meta">{{ viewer.meta }}</small>
        <button v-if="viewer.file" class="btn btn-sm btn-primary" :disabled="viewer.loading || !!viewer.error" @click="downloadFile(viewer.log, viewer.file)"><i class="fa fa-download"></i> تحميل</button>
        <button class="btn btn-sm btn-outline-secondary" @click="viewer.show = false">إغلاق</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import draggable from 'vuedraggable'
import AppLogo from '@/layouts/components/AppLogo.vue'

// SAUD_SPEC A — defaults (also used when the server sends fewer fields)
var DEFAULTS = {
  enabled: true,
  name: 'سعود',
  subtitle: 'المساعد الذكي بالذكاء الاصطناعي',
  welcome: 'أهلاً! أنا سعود، المساعد الذكي بالذكاء الاصطناعي. اسألني عن أي شيء في التحضير الذكي، أو اطلب مني ملف Excel أو PDF أو صورة من هذه الصفحة.',
  model: 'gemini-3.1-flash-lite',
  daily_limit: 50,
  knowledge: 'compact',
  extra_instructions: '',
  action_instructions: '',
  screenshot: true,
  quick_prompts: ['اشرح لي هذه الصفحة', 'صدّر الجدول إلى Excel', 'اطبع الجدول PDF', 'اعمل صورة للجدول'],
  templates: {
    logo: 'school', primary: '#146C43', accent: '#F59E0B', paper: 'A4',
    header: '', footer: 'التحضير الذكي — tahdir.net', font_size: 12, show_dates: true,
  },
  // v2 (SAUD_SPEC F1)
  actions: { excel: true, pdf: true, image: true, chart: true, open_page: true, custom_design: true },
  custom_design: { max_chars: 4000 },
  history_turns: 6,
  max_message_chars: 1000,
  show_on_mobile: true,
  position: 'left',
  schools: { mode: 'all', ids: [] },
  hours: { enabled: false, days: [0, 1, 2, 3, 4, 5, 6], from: '00:00', to: '23:59' },
  answer_style: 'short',
  page_rules: [],
}
var ACTION_KEYS = ['excel', 'pdf', 'image', 'chart', 'open_page', 'custom_design']
var RULE_MAX = { instructions: 2000, welcome: 600, title: 80, pattern: 200, prompts: 8, prompt: 80 }
// USD per 1M tokens (SAUD_SPEC «Logging & limits»); unknown model → 3.1 prices
var PRICES = {
  'gemini-3.1-flash-lite': { in: 0.25, cached: 0.025, out: 1.5 },
  'gemini-3.5-flash-lite': { in: 0.3, cached: 0.03, out: 2.5 },
}
// ≈ tokens of our own rules + a page snapshot sent with every message (for the cost hint only)
var BASE_TOKENS = 1800
var ACTIONS = {
  excel: { icon: 'fa-file-excel-o', cls: 'excel', short: 'Excel', name: 'ملف Excel', button: 'تحميل Excel' },
  pdf: { icon: 'fa-file-pdf-o', cls: 'pdf', short: 'PDF', name: 'ملف PDF', button: 'تحميل PDF' },
  image: { icon: 'fa-picture-o', cls: 'image', short: 'صورة', name: 'صورة', button: 'حفظ الصورة' },
  chart: { icon: 'fa-bar-chart', cls: 'chart', short: 'رسم', name: 'رسم بياني', button: 'عرض الرسم' },
  open_page: { icon: 'fa-external-link', cls: 'page', short: 'صفحة', name: 'فتح صفحة', button: 'افتح الصفحة' },
  design: { icon: 'fa-paint-brush', cls: 'design', short: 'تصميم', name: 'تصميم مخصص', button: 'حفظ التصميم' },
}
var SCOPES = { ask: 'يسأل: الصفحة الحالية أم كل البيانات', page: 'الصفحة الحالية', all: 'كل البيانات' }
var OPS = { eq: '=', in: 'ضمن', contains: 'يحتوي', gt: '>', lt: '<' }
var TEMPLATES = { table: 'جدول', cards: 'بطاقات', summary: 'ملخص' }
var CHARTS = { bar: 'أعمدة', pie: 'دائري', line: 'خطي' }
var LIMIT = 30
var MUTED = '#66766D', LINE = '#E1E9E4'

var SAMPLE_PAGE = {
  route: '/_students/list',
  title: 'قائمة الطلاب',
  filters: { 'الفصل': '3/أ', 'التاريخ': '2026-10-31' },
  cards: [{ label: 'حاضر', value: 412 }, { label: 'غائب', value: 31 }, { label: 'متأخر', value: 29 }],
  tables: [{
    id: 't1', title: 'الطلاب', row_count: 472, visible_count: 50,
    columns: [
      { key: 'c0', label: 'الاسم', type: 'text', personal: true },
      { key: 'c1', label: 'الفصل', type: 'enum' },
      { key: 'c2', label: 'الحالة', type: 'enum' },
      { key: 'c3', label: 'وقت الحضور', type: 'time' },
    ],
    stats: {
      c1: { top: [['3/أ', 32], ['3/ب', 30], ['4/أ', 29]] },
      c2: { top: [['حاضر', 412], ['غائب', 31], ['متأخر', 29]] },
    },
  }],
  texts: ['آخر تحديث للحضور قبل 5 دقائق'],
}

function clone(o) { return JSON.parse(JSON.stringify(o)) }
function esc(v) {
  return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] })
}
// the kind of file an action builds (as src/saud/saud.js kind_of)
function kindOf(a) {
  if (!a) return ''
  if (a.type == 'excel' || a.type == 'pdf' || a.type == 'image') return a.type
  if (a.type == 'chart') return 'image'
  if (a.type == 'design') return a.format == 'pdf' ? 'pdf' : 'image'
  return ''
}
// «شعار المدرسة» stand-in for {{logo}} (the school's logo isn't in the log)
var LOGO_SVG = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="96" height="56"><rect x="1" y="1" width="94" height="54" rx="10" fill="#EEF2F0" stroke="#C9D6CF" stroke-dasharray="4 3"/><text x="48" y="33" font-family="Tahoma" font-size="12" fill="#66766D" text-anchor="middle">الشعار</text></svg>')
// SAUD_SPEC F3: a saved make_design template (sanitized by the server) → a static page for a sandboxed iframe.
// Only the log's own fields are filled (title, school, the log's date); the row values are never saved, so
// {{#rows}} is shown 3 times with the column keys in their place. A CSP meta blocks anything from outside.
function designDoc(a, log, t) {
  t = t || {}
  var d = new Date((log && log.at) || Date.now())
  var fmt = function (cal) { try { return new Intl.DateTimeFormat('ar-SA-u-ca-' + cal + '-nu-latn', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Riyadh' }).format(d) } catch (e) { return d.toISOString().slice(0, 10) } }
  var vals = { title: a.title || '', school: (log && log.school_name) || '', date: fmt('gregory'), date_hijri: fmt('islamic-umalqura'), count: '—' }
  var fill = function (html, n) {
    return html.replace(/\{\{\s*([A-Za-z_][\w-]*)\s*\}\}/g, function (m, k, off, all) {
      var inTag = all.lastIndexOf('<', off) > all.lastIndexOf('>', off)
      if (k == 'logo') return inTag ? LOGO_SVG : '<img src="' + LOGO_SVG + '" alt="" style="max-height:70px;max-width:120px">'
      if (k == 'n' || k == 'index') return String(n || 1)
      if (Object.prototype.hasOwnProperty.call(vals, k)) return esc(vals[k])
      return inTag ? '' : '<span class="sd-ph">' + esc(k) + '</span>'
    })
  }
  var body = fill(String(a.html || '').replace(/\{\{\s*#\s*rows\s*\}\}([\s\S]*?)\{\{\s*\/\s*rows\s*\}\}/g, function (m, inner) {
    return [1, 2, 3].map(function (n) { return fill(inner, n) }).join('')
  }))
  var primary = hex(t.primary, DEFAULTS.templates.primary)
  var accent = hex(t.accent, DEFAULTS.templates.accent)
  var W = t.paper === 'A4-landscape' ? 1123 : 794
  return '<!doctype html><html lang="ar" dir="rtl"><head><meta charset="utf-8">'
    + '<meta http-equiv="Content-Security-Policy" content="default-src \'none\'; img-src data:; style-src \'unsafe-inline\'; font-src data:">'
    + '<style>html{background:#E9EEEB}body{box-sizing:border-box;width:' + W + 'px;max-width:100%;margin:16px auto;padding:28px;background:#fff;color:#1f2937;'
    + 'direction:rtl;text-align:right;font-family:Tahoma,Arial,sans-serif;font-size:' + int(t.font_size, 9, 18, 12) + 'px;line-height:1.7;'
    + '--primary:' + primary + ';--accent:' + accent + ';box-shadow:0 4px 18px rgba(11,61,42,.12)}'
    + 'table{width:100%;border-collapse:collapse;margin:8px 0}th,td{border:1px solid #d6dbe1;padding:5px 8px;vertical-align:middle}'
    + 'th{background:' + primary + ';color:#fff;font-weight:700}h1,h2,h3{color:' + primary + ';margin:0 0 8px;line-height:1.5}p{margin:0 0 6px}img{max-width:100%}'
    + '.sd-ph{display:inline-block;padding:0 6px;border-radius:4px;background:#EEF2F0;color:#66766D;font:11px/1.7 Menlo,Consolas,monospace;direction:ltr}</style>'
    + '</head><body>' + body + '</body></html>'
}
// a grey outline of the chart's type (the values are counted in the school's browser and never saved)
function chartSkel(a) {
  var type = ['bar', 'pie', 'line'].indexOf(a.chart) >= 0 ? a.chart : 'bar'
  var vals = [7, 5, 6, 3, 4]
  var base = {
    chart: { type: type, toolbar: { show: false }, animations: { enabled: false }, sparkline: { enabled: true } },
    colors: ['#B9CCC1'], dataLabels: { enabled: false }, tooltip: { enabled: false }, legend: { show: false },
    states: { hover: { filter: { type: 'none' } }, active: { filter: { type: 'none' } } },
  }
  if (type == 'pie') {
    return { type: type, series: vals, options: Object.assign(base, { labels: ['', '', '', '', ''], colors: ['#7FA892', '#9CC3AC', '#B9CCC1', '#D3DFD8', '#E6EEE9'], stroke: { width: 1 } }) }
  }
  return { type: type, series: [{ name: '', data: vals }], options: Object.assign(base, { plotOptions: { bar: { borderRadius: 2, columnWidth: '60%' } }, stroke: { width: type == 'line' ? 3 : 0, curve: 'smooth' } }) }
}
function int(v, min, max, def) {
  var n = parseInt(v, 10)
  return isNaN(n) ? def : Math.max(min, Math.min(max, n))
}
function str(v, def) { return typeof v == 'string' ? v : def }
function bool(v, def) {
  if (v === true || v === 'true' || v === 1 || v === '1') return true
  if (v === false || v === 'false' || v === 0 || v === '0') return false
  return def
}
function hex(v, def) { return /^#[0-9a-f]{6}$/i.test(v || '') ? v : def }
function hhmm(v, def) { return /^([01]\d|2[0-3]):[0-5]\d$/.test(v || '') ? v : def }
function uid() { return 'r' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6) }
function isObj(v) { return !!v && typeof v == 'object' && !Array.isArray(v) }
function strList(v) { return Array.isArray(v) ? v.filter(function (q) { return typeof q == 'string' && q.trim() }) : [] }
// a page rule (SAUD_SPEC F1) with every field typed; a rule without an id gets one
function normRule(r) {
  return {
    id: typeof r.id == 'string' && r.id ? r.id : uid(),
    pattern: str(r.pattern, '').trim(),
    title: str(r.title, ''),
    enabled: bool(r.enabled, true),
    instructions: str(r.instructions, ''),
    quick_prompts: strList(r.quick_prompts),
    welcome: str(r.welcome, ''),
    allow_all_data: bool(r.allow_all_data, true),
  }
}
// '/x/y' (exact) or '/x*' (prefix); null = no match. More specific = exact, then the longer prefix
// (as the server: duplicate patterns are rejected, so the list order never decides).
function ruleMatch(pattern, route) {
  if (!pattern || !route) return null
  if (pattern.slice(-1) == '*') {
    var p = pattern.slice(0, -1)
    return route.indexOf(p) === 0 ? { exact: false, len: p.length } : null
  }
  return route === pattern ? { exact: true, len: pattern.length } : null
}
function cleanRoute(v) {
  v = String(v || '').trim().replace(/[?#].*$/, '')
  if (!v) return ''
  if (v.charAt(0) != '/') v = '/' + v
  return v.length > 1 ? v.replace(/\/+$/, '') : v
}
function riyadhDay(offsetDays) {
  return new Date(Date.now() + 3 * 3600 * 1000 + (offsetDays || 0) * 86400000).toISOString().slice(0, 10)
}
// for search: no tashkeel, one alef / ya / ta marbuta
function norm(s) {
  return (s == null ? '' : String(s)).toLowerCase().replace(/[ً-ْـ]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').trim()
}
// server settings → a complete, typed form (missing / invalid fields → defaults)
function normalize(s, d) {
  s = s || {}
  var t = s.templates || {}
  var dt = d.templates
  var sc = isObj(s.schools) ? s.schools : {}
  var h = isObj(s.hours) ? s.hours : {}
  return {
    enabled: bool(s.enabled, d.enabled),
    name: str(s.name, d.name),
    subtitle: str(s.subtitle, d.subtitle),
    welcome: str(s.welcome, d.welcome),
    model: str(s.model, d.model) || d.model,
    daily_limit: int(s.daily_limit, 1, 1000, d.daily_limit),
    knowledge: s.knowledge === 'full' ? 'full' : 'compact',
    extra_instructions: str(s.extra_instructions, ''),
    action_instructions: str(s.action_instructions, ''),
    screenshot: bool(s.screenshot, d.screenshot),
    quick_prompts: Array.isArray(s.quick_prompts) ? s.quick_prompts.filter(function (q) { return typeof q == 'string' && q.trim() }) : d.quick_prompts.slice(),
    templates: {
      logo: ['school', 'tahdir', 'none'].indexOf(t.logo) >= 0 ? t.logo : dt.logo,
      primary: hex(t.primary, dt.primary),
      accent: hex(t.accent, dt.accent),
      paper: t.paper === 'A4-landscape' ? 'A4-landscape' : 'A4',
      header: str(t.header, dt.header),
      footer: str(t.footer, dt.footer),
      font_size: int(t.font_size, 9, 18, dt.font_size),
      show_dates: bool(t.show_dates, dt.show_dates),
    },
    actions: ACTION_KEYS.reduce(function (o, k) { o[k] = bool((isObj(s.actions) ? s.actions : {})[k], d.actions[k]); return o }, {}),
    custom_design: { max_chars: int((isObj(s.custom_design) ? s.custom_design : {}).max_chars, 500, 8000, d.custom_design.max_chars) },
    history_turns: int(s.history_turns, 0, 10, d.history_turns),
    max_message_chars: int(s.max_message_chars, 100, 2000, d.max_message_chars),
    show_on_mobile: bool(s.show_on_mobile, d.show_on_mobile),
    position: s.position === 'right' ? 'right' : 'left',
    schools: {
      mode: ['all', 'allow', 'deny'].indexOf(sc.mode) >= 0 ? sc.mode : 'all',
      ids: (Array.isArray(sc.ids) ? sc.ids : []).map(String).filter(function (x, i, a) { return x && a.indexOf(x) == i }),
    },
    hours: {
      enabled: bool(h.enabled, d.hours.enabled),
      days: Array.isArray(h.days) ? h.days.map(Number).filter(function (x, i, a) { return x >= 0 && x <= 6 && a.indexOf(x) == i }).sort() : d.hours.days.slice(),
      from: hhmm(h.from, d.hours.from),
      to: hhmm(h.to, d.hours.to),
    },
    answer_style: ['short', 'normal', 'detailed'].indexOf(s.answer_style) >= 0 ? s.answer_style : d.answer_style,
    page_rules: (Array.isArray(s.page_rules) ? s.page_rules : []).filter(isObj).map(normRule),
  }
}

export default {
  components: { VueApexCharts, AppLogo, draggable },
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      tab: 'settings',
      state: 'loading', // loading | ready | missing (older server) | error
      errorText: '',
      saving: false,
      busy: false,
      defaults: clone(DEFAULTS),
      saved: clone(DEFAULTS),
      form: clone(DEFAULTS),
      models: [],
      key: { set: false, hint: '' },
      kStats: {},
      promptInput: '',
      // v2: school-route whitelist for the rule picker, prices from the server, names of allow / deny schools
      routes: [],
      priceMap: clone(PRICES),
      schoolNames: {},
      schoolSearch: { q: '', loading: false, done: false, results: [], error: '', manual: '' },
      schoolTimer: null,
      tester: { route: '/_students/list' },
      ruleEd: { open: false, index: -1, mode: 'pick', q: '', pick: '', prompt: '', error: '', r: normRule({}) },
      dayNames: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
      actionList: [
        { key: 'excel', cls: 'excel', icon: 'fa-file-excel-o', title: 'ملفات Excel', text: 'تصدير الجدول بالأعمدة والترتيب والفلتر.' },
        { key: 'pdf', cls: 'pdf', icon: 'fa-file-pdf-o', title: 'ملفات PDF', text: 'طباعة بقالب المدرسة (الشعار والألوان).' },
        { key: 'image', cls: 'image', icon: 'fa-picture-o', title: 'صورة', text: 'صورة PNG للجدول أو البطاقات للمشاركة.' },
        { key: 'chart', cls: 'chart', icon: 'fa-bar-chart', title: 'رسم بياني', text: 'أعمدة أو دائري أو خطي من بيانات الصفحة.' },
        { key: 'open_page', cls: 'page', icon: 'fa-external-link', title: 'فتح الصفحات', text: 'زر «افتح الصفحة» عندما يسأل أين يجد شيئاً.' },
        { key: 'custom_design', cls: 'design', icon: 'fa-paint-brush', title: 'تصاميم مخصصة (HTML قصير)', text: 'تصميم حر عندما لا تناسب القوالب الجاهزة.' },
      ],
      styleOptions: [
        { value: 'short', title: 'قصير', min: 40, max: 120, text: 'جملة إلى ثلاث جمل مباشرة — أقل توكن إخراج.' },
        { value: 'normal', title: 'عادي', min: 120, max: 300, text: 'فقرة قصيرة أو خطوات مرقمة عند الحاجة.' },
        { value: 'detailed', title: 'مفصّل', min: 300, max: 700, text: 'شرح كامل بالخطوات والأمثلة — الأعلى تكلفة.' },
      ],
      ruleExamples: [
        'إذا طلب تقريراً اجعل التجميع حسب الفصل',
        'لا تقترح تصدير كل البيانات إلا إذا طلبها',
        'اشرح أعمدة الجدول باختصار إذا سأل عن الصفحة',
        'في PDF اجعل الورق عرضياً لأن الأعمدة كثيرة',
      ],
      rulePlaceholder: 'أمثلة:\n• هذه صفحة استعراض الطلاب: إذا طلب تقريراً اجعل التجميع حسب الفصل\n• في PDF اجعل الورق عرضياً لأن الأعمدة كثيرة\n• لا تقترح تصدير كل البيانات إلا إذا طلبها',
      paperScale: 1,
      resetting: '',
      usage: { from: riyadhDay(-29), to: riyadhDay(0), q: '', sort: { key: 'messages', dir: 'desc' }, show: 50, data: null, loading: false, missing: false },
      logs: { rows: [], total: 0, page: 0, school_id: '', q: '', loading: false, loaded: false, missing: false },
      detail: { open: false, loading: false, row: null, log: null },
      // the conversation files: blob URLs by '<log id>:<i>' (fetched with POST, never a key in a URL)
      fileCache: { urls: {}, busy: {}, order: [] },
      viewer: { show: false, kind: '', title: '', url: '', html: '', log: null, file: null, loading: false, error: '', meta: '' },
      test: { message: 'صدّر الطلاب الغائبين إلى Excel مرتبين حسب الفصل', route: SAMPLE_PAGE.route, page: '', sending: false, pending: '', results: [], missing: false },
      searchTimer: null,
      logoOptions: [
        { value: 'school', text: 'شعار المدرسة', icon: 'fa-university' },
        { value: 'tahdir', text: 'التحضير الذكي', icon: 'fa-check-square' },
        { value: 'none', text: 'بدون', icon: 'fa-ban' },
      ],
      primarySwatches: ['#146C43', '#0F766E', '#1E3A8A', '#7F1D1D', '#4C1D95', '#111827'],
      accentSwatches: ['#F59E0B', '#CA8A04', '#DC2626', '#2563EB', '#DB2777', '#059669'],
      ranges: [{ days: 1, text: 'اليوم' }, { days: 7, text: '7 أيام' }, { days: 30, text: '30 يوماً' }, { days: 90, text: '90 يوماً' }],
      schoolCols: [
        { key: 'name', text: 'المدرسة' },
        { key: 'today', text: 'اليوم' },
        { key: 'messages', text: 'رسائل الفترة' },
        { key: 'tokens', text: 'التوكن' },
        { key: 'cost_usd', text: 'التكلفة' },
        { key: 'last_at', text: 'آخر استخدام' },
      ],
      actionExamples: [
        'ضع شعار المدرسة واسمها أعلى كل PDF',
        'في Excel اجعل صف العناوين بلون المدرسة',
        'رتّب الطلاب حسب الفصل ثم الاسم إذا لم يُحدَّد ترتيب',
        'ميّز الغائبين باللون الأحمر في PDF والصور',
        'استخدم قالب البطاقات للصور إذا كانت الأعمدة 3 أو أقل',
        'اجعل الرسم البياني دائرياً لنسب الحضور والغياب',
      ],
      extraExamples: [
        'أجب بلهجة سعودية ودودة وباختصار',
        'إذا سأل عن الأسعار وجّهه لصفحة الاشتراكات ولا تذكر أرقاماً',
        'إذا لم تعرف الإجابة اقترح فتح تذكرة دعم فني',
        'ابدأ بخطوات مرقمة عند شرح طريقة عمل شيء',
      ],
      actionPlaceholder: 'أمثلة:\n• ضع شعار المدرسة واسمها أعلى كل PDF\n• في ملفات Excel اجعل صف العناوين بلون المدرسة وثبّته\n• رتّب الطلاب حسب الفصل ثم الاسم إذا لم يحدد المستخدم ترتيباً\n• ميّز الغائبين باللون الأحمر في PDF والصور',
      extraPlaceholder: 'أمثلة:\n• أجب بلهجة سعودية ودودة وباختصار\n• إذا سأل عن الأسعار وجّهه لصفحة «الاشتراكات» ولا تذكر أرقاماً\n• إذا لم تعرف الإجابة اقترح فتح تذكرة دعم فني',
      sampleRows: [
        { name: 'عبدالله محمد الشهري', cls: '3/أ', status: 'غائب', time: '—', hl: true, note: 'بدون عذر' },
        { name: 'فيصل أحمد القحطاني', cls: '3/أ', status: 'متأخر', time: '07:42', note: '12 دقيقة' },
        { name: 'سلمان خالد العتيبي', cls: '3/أ', status: 'غائب', time: '—', hl: true, note: 'عذر طبي' },
        { name: 'تركي سعد الدوسري', cls: '3/أ', status: 'متأخر', time: '07:38', note: '8 دقائق' },
        { name: 'نواف عبدالرحمن الغامدي', cls: '3/أ', status: 'غائب', time: '—', hl: true, note: 'بدون عذر' },
        { name: 'ريان ماجد الحربي', cls: '3/أ', status: 'متأخر', time: '07:51', note: '21 دقيقة' },
      ],
      sampleCards: [
        { label: 'حاضر', value: 26 },
        { label: 'غائب', value: 3, accent: true },
        { label: 'متأخر', value: 3 },
      ],
    }
  },
  computed: {
    tabs() {
      return [
        { key: 'settings', title: 'الإعدادات', icon: 'fa-sliders' },
        { key: 'options', title: 'الإمكانيات والخيارات', icon: 'fa-toggle-on' },
        { key: 'templates', title: 'تعليمات التنفيذ والقوالب', icon: 'fa-file-text-o' },
        { key: 'pages', title: 'تعليمات الصفحات', icon: 'fa-map-signs', badge: this.form.page_rules.length || null },
        { key: 'usage', title: 'الاستهلاك', icon: 'fa-bar-chart' },
        { key: 'logs', title: 'المحادثات', icon: 'fa-comments-o', badge: this.logs.total ? this.num(this.logs.total) : null },
        { key: 'test', title: 'تجربة', icon: 'fa-flask' },
      ]
    },
    tpl() { return this.form.templates },
    dirty() { return JSON.stringify(this.form) != JSON.stringify(this.saved) },
    // which tabs have unsaved edits (shown in the save bar)
    dirtyTabs() {
      if (!this.dirty) return []
      var f = this.form, v = this.saved
      var diff = function (keys) { return keys.some(function (k) { return JSON.stringify(f[k]) != JSON.stringify(v[k]) }) }
      var out = []
      if (diff(['enabled', 'name', 'subtitle', 'welcome', 'model', 'daily_limit', 'knowledge', 'screenshot', 'quick_prompts'])) out.push('الإعدادات')
      if (diff(['actions', 'custom_design', 'history_turns', 'max_message_chars', 'show_on_mobile', 'position', 'schools', 'hours', 'answer_style'])) out.push('الإمكانيات والخيارات')
      if (diff(['action_instructions', 'extra_instructions', 'templates'])) out.push('تعليمات التنفيذ والقوالب')
      if (diff(['page_rules'])) out.push('تعليمات الصفحات')
      return out
    },
    actionsOn() { var a = this.form.actions; return ACTION_KEYS.filter(function (k) { return a[k] }).length },
    outRatio() { var p = this.price(this.form.model); return Math.round(p.out / (p.in || 1)) },
    historyHint() {
      var n = int(this.form.history_turns, 0, 10, 6)
      if (!n) return 'لا يتذكر سعود ما قبل الرسالة الحالية — أرخص، لكنه لن يفهم «وكمان PDF» بعد طلب Excel.'
      var tok = n * 200
      return 'كل رسالة تحمل آخر ' + n + ' رسائل من المحادثة: حتى ≈ ' + this.num(tok) + ' توكن إدخال إضافية (≈ ' + this.usd((tok * this.price(this.form.model).in) / 1e6) + ' للرسالة). 4–6 كافية عادةً.'
    },
    testerResult() { return this.routeInfo(this.tester.route) },
    testerPrompts() {
      var w = this.testerResult.win
      return w && w.rule.quick_prompts.length ? w.rule.quick_prompts : this.form.quick_prompts
    },
    testRule() { return this.routeInfo(this.test.route) },
    pickerRoutes() {
      var q = norm(this.ruleEd.q)
      return this.routes.filter(function (r) { return !q || norm(r.title).indexOf(q) >= 0 || r.path.toLowerCase().indexOf(q) >= 0 }).slice(0, 120)
    },
    pickHasParams() { return this.ruleEd.pick.indexOf('/:') >= 0 },
    ruleCovers() {
      var p = this.ruleEd.r.pattern
      return this.routes.filter(function (r) { return ruleMatch(p, r.path) })
    },
    limitNum() { return int(this.form.daily_limit, 1, 1000, this.defaults.daily_limit) },
    modelOptions() {
      var list = (this.models.length ? this.models : Object.keys(PRICES)).slice()
      if (this.form.model && list.indexOf(this.form.model) < 0) list.push(this.form.model)
      return list
    },
    hasKStats() { return !!(this.kStats && (this.kStats.compact_tokens || this.kStats.full_tokens)) },
    // the preview keeps its last valid colour while a hex is being typed
    pPrimary() { return hex(this.tpl.primary, this.saved.templates.primary) },
    pAccent() { return hex(this.tpl.accent, this.saved.templates.accent) },
    paperSize() { return this.tpl.paper == 'A4-landscape' ? { w: 842, h: 595 } : { w: 595, h: 842 } },
    paperStyle() {
      return {
        width: this.paperSize.w + 'px',
        height: this.paperSize.h + 'px',
        fontSize: int(this.tpl.font_size, 9, 18, 12) + 'px',
        transform: 'scale(' + this.paperScale + ')',
      }
    },
    todayIso() { return riyadhDay(0) },
    hijriToday() {
      try {
        return new Intl.DateTimeFormat('ar-SA-u-ca-islamic-umalqura-nu-latn', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Riyadh' }).format(new Date())
      } catch (e) { return '' }
    },
    gregToday() {
      try {
        return new Intl.DateTimeFormat('ar-SA-u-ca-gregory-nu-latn', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Asia/Riyadh' }).format(new Date()) + ' م'
      } catch (e) { return this.todayIso }
    },

    // ---- usage
    avgCost() {
      var t = this.usage.data && this.usage.data.totals
      return t && t.messages ? (Number(t.cost_usd) || 0) / t.messages : 0
    },
    // per_day with the missing days of the range filled with zeros (ranges up to 120 days)
    dayData() {
      var rows = (this.usage.data && this.usage.data.per_day) || []
      var by = {}
      rows.forEach(function (r) { by[r.day] = r })
      var from = this.usage.from || (rows[0] && rows[0].day)
      var to = this.usage.to || (rows.length && rows[rows.length - 1].day)
      if (!from || !to || from > to) return rows
      var out = []
      var d = new Date(from + 'T00:00:00Z')
      var end = new Date(to + 'T00:00:00Z')
      if ((end - d) / 86400000 > 120) return rows
      for (; d <= end; d = new Date(d.getTime() + 86400000)) {
        var k = d.toISOString().slice(0, 10)
        out.push(by[k] || { day: k, messages: 0, cost_usd: 0 })
      }
      return out
    },
    daySeries() {
      var x = function (r) { return new Date(r.day + 'T00:00:00Z').getTime() }
      return [
        { name: 'الرسائل', type: 'column', data: this.dayData.map(function (r) { return { x: x(r), y: Number(r.messages) || 0 } }) },
        { name: 'التكلفة', type: 'line', data: this.dayData.map(function (r) { return { x: x(r), y: Math.round((Number(r.cost_usd) || 0) * 10000) / 10000 } }) },
      ]
    },
    dayOptions() {
      var g = this
      return {
        chart: { toolbar: { show: false }, zoom: { enabled: false }, fontFamily: 'Noto Kufi Arabic, sans-serif', foreColor: MUTED, animations: { enabled: false } },
        colors: ['#146C43', '#F59E0B'],
        stroke: { width: [0, 3], curve: 'smooth' },
        plotOptions: { bar: { columnWidth: '60%', borderRadius: 3 } },
        grid: { borderColor: LINE, strokeDashArray: 4, padding: { left: 8, right: 8 } },
        dataLabels: { enabled: false },
        legend: { position: 'top', horizontalAlign: 'right', fontSize: '12px' },
        markers: { size: 0 },
        xaxis: {
          type: 'datetime',
          labels: { datetimeUTC: true, format: 'dd/MM', rotate: 0, hideOverlappingLabels: true },
          axisTicks: { show: false },
        },
        yaxis: [
          { title: { text: 'الرسائل' }, min: 0, tickAmount: 4, forceNiceScale: true, labels: { formatter: function (v) { return Math.round(v) } } },
          { opposite: true, title: { text: 'التكلفة $' }, min: 0, tickAmount: 4, labels: { formatter: function (v) { return '$' + Number(v).toFixed(v < 1 ? 3 : 2) } } },
        ],
        tooltip: {
          theme: 'light', shared: true, intersect: false,
          x: { format: 'dd/MM/yyyy' },
          y: { formatter: function (v, o) { return o && o.seriesIndex == 1 ? g.usd(v) : g.num(v) + ' رسالة' } },
        },
      }
    },
    schoolRows() {
      var q = norm(this.usage.q)
      var rows = ((this.usage.data && this.usage.data.per_school) || []).filter(function (r) {
        return !q || norm(r.name).indexOf(q) >= 0 || String(r.school_id).indexOf(q) >= 0
      })
      var k = this.usage.sort.key
      var dir = this.usage.sort.dir == 'asc' ? 1 : -1
      return rows.slice().sort(function (a, b) {
        var x = a[k], y = b[k]
        if (k == 'name') return dir * String(x || '').localeCompare(String(y || ''), 'ar')
        if (k == 'last_at') { x = x ? new Date(x).getTime() : 0; y = y ? new Date(y).getTime() : 0 }
        return dir * ((Number(x) || 0) - (Number(y) || 0))
      })
    },
    schoolRowsShown() { return this.schoolRows.slice(0, this.usage.show) },

    // ---- logs
    logPages() { return Math.max(1, Math.ceil((this.logs.total || 0) / LIMIT)) },
    // the actions as sent to the browser (action_data), else only their types (older server)
    detailActions() {
      var l = this.detail.log
      if (!l) return []
      return Array.isArray(l.action_data) && l.action_data.length ? l.action_data : (l.actions || [])
    },
    // designs / charts of the detail with no uploaded file: the saved design (rebuilt) or the chart's outline
    detailPreviews() {
      var l = this.detail.log
      if (!l) return []
      var files = Array.isArray(l.files) ? l.files : []
      return this.detailActions.map(function (a, j) { return { a: a, j: j } }).filter(function (p) {
        if (!isObj(p.a) || (p.a.type != 'design' && p.a.type != 'chart')) return false
        if (p.a.type == 'design' && !p.a.html) return false
        return !files.some(function (f) { return f.action === p.j || ((f.action == null || f.action < 0) && f.kind == kindOf(p.a)) })
      }).map(function (p) { return p.a.type == 'chart' ? Object.assign(p, { skel: chartSkel(p.a) }) : p })
    },
    schoolOptions() {
      var seen = {}
      var out = []
      var add = function (id, name) {
        if (!id || id == 'admin-test' || seen[id]) return
        seen[id] = 1
        out.push({ id: id, name: name || id })
      }
      ;((this.usage.data && this.usage.data.per_school) || []).forEach(function (r) { add(r.school_id, r.name) })
      this.logs.rows.forEach(function (r) { add(r.school_id, r.school_name) })
      return out.sort(function (a, b) { return String(a.name).localeCompare(String(b.name), 'ar') })
    },

    // ---- test
    pageError() {
      if (!this.test.page.trim()) return ''
      try {
        var p = JSON.parse(this.test.page)
        if (!p || typeof p != 'object' || Array.isArray(p)) return 'يجب أن تكون لقطة الصفحة كائن JSON { … }'
        if (this.pageBytes > 8192) return 'لقطة الصفحة أكبر من 8 كيلوبايت (' + this.pageBytes + ' بايت)'
        return ''
      } catch (e) {
        return 'JSON غير صحيح: ' + e.message
      }
    },
    pageBytes() {
      try { return new Blob([JSON.stringify(JSON.parse(this.test.page))]).size } catch (e) { return new Blob([this.test.page]).size }
    },
    testPrompts() {
      return (this.saved.quick_prompts || []).concat(['اعمل رسم بياني دائري لحالات الحضور', 'وين ألقى صفحة الإجازات؟'])
    },
  },
  watch: {
    'form.templates.paper': function () { this.$nextTick(this.measurePaper) },
  },
  created() {
    var t = (this.$route.query.tab || '').toString()
    if (['settings', 'options', 'templates', 'pages', 'usage', 'logs', 'test'].indexOf(t) >= 0) this.tab = t
    this.test.page = this.samplePage()
    // files being fetched (not reactive)
    this.fileJobs = {}
    this.loadAll()
  },
  mounted() {
    window.addEventListener('resize', this.measurePaper)
  },
  beforeDestroy() {
    var urls = this.fileCache.urls
    Object.keys(urls).forEach(function (k) { URL.revokeObjectURL(urls[k]) })
    window.removeEventListener('resize', this.measurePaper)
    clearTimeout(this.searchTimer)
    clearTimeout(this.schoolTimer)
  },
  methods: {
    // JSON bodies (typed booleans / numbers, nested templates, empty quick_prompts survive); same jwt guard as callcenter
    post(path, body) {
      return $.ajax({
        url: api + '/admin/saud' + path,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(Object.assign({ jwt: this.jwt }, body || {})),
        timeout: path == '/test' ? 90000 : 30000,
      })
    },
    // an older server has no /admin/saud/* → 404 / not JSON
    isMissing(xhr, textStatus) {
      return !!xhr && (xhr.status == 404 || xhr.status == 405 || textStatus == 'parsererror')
    },
    fail(r) { alert(this.errText(r) || 'تعذر الاتصال بالسيرفر', 200) },
    // the admin guard answers {status:200, response:<the jwt>} — never show that
    errText(r) {
      var t = r && typeof r.response == 'string' ? r.response : ''
      if (t && t == this.jwt) return 'انتهت الجلسة — سجّل الدخول من جديد'
      return t
    },
    setTab(t) {
      this.tab = t
      this.onTab()
      if (this.$route.query.tab != t) this.$router.replace({ query: Object.assign({}, this.$route.query, { tab: t }) }).catch(function () {})
    },
    onTab() {
      this.$nextTick(this.showActiveTab)
      if (this.state != 'ready') return
      if (this.tab == 'logs' && !this.logs.loaded) this.loadLogs()
      if ((this.tab == 'usage' || this.tab == 'logs') && !this.usage.data && !this.usage.loading && !this.usage.missing) this.loadUsage()
      if (this.tab == 'templates') this.$nextTick(this.measurePaper)
    },

    // phones: the tab strip scrolls — keep the active tab in view
    showActiveTab() {
      var el = this.$el && this.$el.querySelector('.sd-tab.active')
      var bar = el && el.parentNode
      if (!bar || bar.scrollWidth <= bar.clientWidth) return
      var b = bar.getBoundingClientRect()
      var r = el.getBoundingClientRect()
      if (r.left < b.left) bar.scrollLeft -= b.left - r.left + 12
      else if (r.right > b.right) bar.scrollLeft += r.right - b.right + 12
    },

    // ---------------------------------------------------------------- settings
    loadAll() {
      var g = this
      this.state = 'loading'
      this.post('/settings').done(function (r) {
        if (!r || r.status != 100 || !r.response) {
          g.errorText = g.errText(r)
          g.state = 'error'
          return
        }
        g.applySettings(r.response)
        g.state = 'ready'
        g.loadUsage(true)
        g.$nextTick(g.onTab)
      }).fail(function (xhr, ts) {
        g.errorText = ''
        g.state = g.isMissing(xhr, ts) ? 'missing' : 'error'
      })
    },
    // res = {settings, defaults, models, key:{set, hint}, knowledge_stats}; keepForm: only `enabled` changed
    applySettings(res, keepForm) {
      if (res.settings == null && res.name != null) res = { settings: res }
      if (res.defaults) this.defaults = normalize(res.defaults, DEFAULTS)
      if (Array.isArray(res.models)) this.models = res.models.filter(function (m) { return typeof m == 'string' && m })
      if (res.key) this.key = { set: !!res.key.set, hint: res.key.hint || '' }
      if (res.knowledge_stats !== undefined) this.kStats = res.knowledge_stats || {}
      // v2: the school-route whitelist {path, title} for the page-rule picker
      if (Array.isArray(res.routes)) {
        this.routes = res.routes.filter(function (r) { return r && typeof r.path == 'string' && r.path }).map(function (r) { return { path: r.path, title: r.title || r.path } })
      }
      // the server's price table {model: {input, cached, output}} (USD / 1M)
      if (isObj(res.prices)) {
        var pm = clone(PRICES)
        Object.keys(res.prices).forEach(function (k) {
          var p = res.prices[k]
          if (isObj(p) && p.input != null) pm[k] = { in: Number(p.input) || 0, cached: Number(p.cached) || 0, out: Number(p.output) || 0 }
        })
        this.priceMap = pm
      }
      // optional {school_id: name} for the allow / deny list
      if (isObj(res.school_names)) this.addNames(res.school_names)
      this.saved = normalize(res.settings, this.defaults)
      if (keepForm) this.form.enabled = this.saved.enabled
      else this.form = clone(this.saved)
    },
    body(f) {
      var savedIds = this.saved.page_rules.map(function (r) { return r.id })
      return {
        enabled: f.enabled,
        name: f.name.trim(),
        subtitle: f.subtitle.trim(),
        welcome: f.welcome.trim(),
        model: f.model,
        daily_limit: parseInt(f.daily_limit, 10),
        knowledge: f.knowledge,
        extra_instructions: f.extra_instructions,
        action_instructions: f.action_instructions,
        screenshot: f.screenshot,
        quick_prompts: f.quick_prompts.map(function (q) { return q.trim() }).filter(Boolean),
        templates: {
          logo: f.templates.logo,
          primary: f.templates.primary,
          accent: f.templates.accent,
          paper: f.templates.paper,
          header: f.templates.header.trim(),
          footer: f.templates.footer.trim(),
          font_size: parseInt(f.templates.font_size, 10),
          show_dates: f.templates.show_dates,
        },
        // v2 (SAUD_SPEC F1), exactly these names
        actions: ACTION_KEYS.reduce(function (o, k) { o[k] = !!f.actions[k]; return o }, {}),
        custom_design: { max_chars: parseInt(f.custom_design.max_chars, 10) },
        history_turns: parseInt(f.history_turns, 10),
        max_message_chars: parseInt(f.max_message_chars, 10),
        show_on_mobile: !!f.show_on_mobile,
        position: f.position,
        schools: { mode: f.schools.mode, ids: f.schools.ids.slice() },
        hours: { enabled: !!f.hours.enabled, days: f.hours.days.slice().sort(), from: f.hours.from, to: f.hours.to },
        answer_style: f.answer_style,
        page_rules: f.page_rules.map(function (r) {
          var o = {
            pattern: r.pattern.trim(),
            title: r.title.trim(),
            enabled: !!r.enabled,
            instructions: r.instructions.trim(),
            quick_prompts: r.quick_prompts.map(function (q) { return q.trim() }).filter(Boolean),
            welcome: r.welcome.trim(),
            allow_all_data: !!r.allow_all_data,
          }
          // existing rules keep their id; a new rule is sent without one (the server assigns it)
          return savedIds.indexOf(r.id) >= 0 ? Object.assign({ id: r.id }, o) : o
        }),
      }
    },
    validate(b) {
      if (!b.name) return ['settings', 'اكتب اسم المساعد']
      var n = Number(b.daily_limit)
      if (!(n >= 1 && n <= 1000)) return ['settings', 'الحد اليومي: من 1 إلى 1000 رسالة']
      if (b.extra_instructions.length > 4000 || b.action_instructions.length > 4000) return ['templates', 'التعليمات: 4000 حرف كحد أقصى']
      if (!hex(b.templates.primary) || !hex(b.templates.accent)) return ['templates', 'اكتب اللون بصيغة ‎#RRGGBB‎']
      if (!(b.templates.font_size >= 9 && b.templates.font_size <= 18)) return ['templates', 'حجم الخط: من 9 إلى 18']
      if (!(b.history_turns >= 0 && b.history_turns <= 10)) return ['options', 'الرسائل السابقة: من 0 إلى 10']
      if (!(b.max_message_chars >= 100 && b.max_message_chars <= 2000)) return ['options', 'أقصى طول للرسالة: من 100 إلى 2000 حرف']
      if (!(b.custom_design.max_chars >= 500 && b.custom_design.max_chars <= 8000)) return ['options', 'طول التصميم المخصص: من 500 إلى 8000 حرف']
      if (b.hours.enabled) {
        if (!b.hours.days.length) return ['options', 'أوقات الظهور: اختر يوماً واحداً على الأقل']
        if (!hhmm(b.hours.from) || !hhmm(b.hours.to) || b.hours.from == b.hours.to) return ['options', 'أوقات الظهور: اختر وقت البداية والنهاية (مختلفين)']
      }
      if (b.schools.mode == 'allow' && !b.schools.ids.length) return ['options', 'اختر مدرسة واحدة على الأقل في «مدارس محددة فقط»، أو اختر «كل المدارس»']
      for (var i = 0; i < b.page_rules.length; i++) {
        var e = this.ruleError(b.page_rules[i], i, b.page_rules)
        if (e) return ['pages', 'قاعدة «' + (b.page_rules[i].title || b.page_rules[i].pattern || (i + 1)) + '»: ' + e]
      }
      return null
    },
    save() {
      var g = this
      var b = this.body(this.form)
      var err = this.validate(b)
      if (err) {
        if (this.tab != err[0]) this.setTab(err[0])
        return alert(err[1], 200)
      }
      this.saving = true
      this.post('/settings/save', b).done(function (r) {
        if (!r || r.status != 100) return g.fail(r)
        g.applySettings(r.response)
        alert('تم الحفظ', 100)
      }).fail(function () { g.fail() }).always(function () { g.saving = false })
    },
    revert() {
      this.form = clone(this.saved)
      this.promptInput = ''
    },
    // the big switch saves at once (other unsaved edits stay in the form)
    setEnabled(ev) {
      var g = this
      var on = ev.target.checked
      var q = on
        ? (this.key.set ? 'تفعيل سعود في لوحات كل المدارس؟' : 'لا يوجد مفتاح Gemini — سيظهر سعود للمدارس لكنه لن يستطيع الرد حتى تحفظ المفتاح. تفعيل على أي حال؟')
        : 'إيقاف سعود؟ سيختفي من لوحات كل المدارس فوراً.'
      if (!confirm(q)) { ev.target.checked = !on; return }
      this.busy = true
      this.post('/settings/save', { enabled: on }).done(function (r) {
        if (!r || r.status != 100) { ev.target.checked = !on; return g.fail(r) }
        g.applySettings(r.response, true)
        alert(on ? 'تم التفعيل: سعود يظهر في لوحات المدارس' : 'تم الإيقاف: سعود لا يظهر للمدارس', 100)
      }).fail(function () { ev.target.checked = !on; g.fail() }).always(function () { g.busy = false })
    },
    price(m) { return this.priceMap[m] || this.priceMap['gemini-3.1-flash-lite'] || PRICES['gemini-3.1-flash-lite'] },
    clampInt(v, min, max, def) { return int(v, min, max, def) },
    rate(v) { return '$' + Number(v).toFixed(v < 0.1 ? 3 : 2) },
    knowledgeCost(kind) {
      var t = Number(kind == 'full' ? this.kStats.full_tokens : this.kStats.compact_tokens) || 0
      return ((t + BASE_TOKENS) * this.price(this.form.model).in) / 1e6
    },
    addPrompt() {
      var q = this.promptInput.trim().slice(0, 80)
      if (!q || this.form.quick_prompts.length >= 8) return
      if (this.form.quick_prompts.indexOf(q) < 0) this.form.quick_prompts.push(q)
      this.promptInput = ''
    },
    editPrompt(i) {
      if (this.promptInput.trim()) this.addPrompt()
      this.promptInput = this.form.quick_prompts[i]
      this.form.quick_prompts.splice(i, 1)
    },
    movePrompt(i, d) {
      var a = this.form.quick_prompts
      var j = i + d
      if (j < 0 || j >= a.length) return
      a.splice(j, 0, a.splice(i, 1)[0])
    },
    addLine(field, line) {
      var cur = (this.form[field] || '').replace(/\s+$/, '')
      if (cur.indexOf(line) >= 0) return
      this.form[field] = (cur ? cur + '\n' : '') + '• ' + line
    },
    resetTemplates() { this.form.templates = clone(this.defaults.templates) },
    measurePaper() {
      var box = this.$refs.paperBox
      if (!box || !box.clientWidth) return
      this.paperScale = Math.min(1, box.clientWidth / this.paperSize.w)
    },
    isHex(v) { return !!hex(v) },
    low(v) { return String(v || '').toLowerCase() },
    rgba(h, a) {
      var m = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(h || '')
      if (!m) return 'transparent'
      return 'rgba(' + parseInt(m[1], 16) + ',' + parseInt(m[2], 16) + ',' + parseInt(m[3], 16) + ',' + a + ')'
    },

    // ---------------------------------------------------------------- الإمكانيات والخيارات
    toggleDay(d) {
      var a = this.form.hours.days
      var i = a.indexOf(d)
      if (i >= 0) a.splice(i, 1)
      else a.push(d)
      a.sort()
    },
    // the mini preview: Saud's button on the chosen side, above the support button on the left
    miniFab(phone) {
      var left = this.form.position == 'left'
      var st = { bottom: left ? (phone ? '34px' : '40px') : (phone ? '8px' : '10px') }
      st[left ? 'left' : 'right'] = phone ? '6px' : '10px'
      return st
    },
    addNames(map) {
      var g = this
      Object.keys(map || {}).forEach(function (id) { if (map[id] && !g.schoolNames[id]) g.$set(g.schoolNames, id, String(map[id])) })
    },
    searchSchoolsLater() {
      var g = this
      clearTimeout(this.schoolTimer)
      this.schoolTimer = setTimeout(function () { g.searchSchools() }, 400)
    },
    // the admin's existing school search (views/users.vue): POST /admin/users/list {q, page} → up to 100 schools
    searchSchools() {
      var g = this
      var q = this.schoolSearch.q.trim().replace(/[.*+?^${}()|[\]\\]/g, '')
      this.schoolSearch.error = ''
      if (q.length < 2) { this.schoolSearch.results = []; this.schoolSearch.done = false; return }
      this.schoolSearch.loading = true
      $.post(api + '/admin/users/list', { jwt: this.jwt, q: q, page: 0 }).done(function (r) {
        if (g.schoolSearch.q.trim().replace(/[.*+?^${}()|[\]\\]/g, '') != q) return
        if (!r || r.status != 100 || !Array.isArray(r.response)) { g.schoolSearch.error = g.errText(r) || 'تعذر البحث'; return }
        g.schoolSearch.results = r.response.slice(0, 20).map(function (u) {
          return { id: String(u._id), name: u.name || String(u._id), phone: u.phone || '', location: u.location || '' }
        })
        var m = {}
        g.schoolSearch.results.forEach(function (x) { m[x.id] = x.name })
        g.addNames(m)
        g.schoolSearch.done = true
      }).fail(function () { g.schoolSearch.error = 'تعذر البحث — أضف المدرسة برقمها' }).always(function () { g.schoolSearch.loading = false })
    },
    addSchool(id, name) {
      if (!id || this.form.schools.ids.indexOf(id) >= 0) return
      this.form.schools.ids.push(id)
      if (name) this.addNames({ [id]: name })
    },
    addManualSchool() {
      var id = this.schoolSearch.manual.trim()
      if (!/^[0-9a-f]{24}$/i.test(id)) return alert('رقم المدرسة 24 حرفاً من 0-9 و a-f', 200)
      this.addSchool(id.toLowerCase())
      this.schoolSearch.manual = ''
    },
    removeSchool(id) {
      var i = this.form.schools.ids.indexOf(id)
      if (i >= 0) this.form.schools.ids.splice(i, 1)
    },

    // ---------------------------------------------------------------- تعليمات الصفحات
    isPrefix(p) { return typeof p == 'string' && p.slice(-1) == '*' },
    // the rule that wins for a route (mirrors the server: exact beats prefix, then the longest prefix)
    routeInfo(raw) {
      var route = cleanRoute(raw)
      var rules = this.form.page_rules
      var out = { route: route, title: '', win: null, others: [], visible: false, why: '' }
      if (!route) return out
      var matches = []
      rules.forEach(function (r, i) {
        var m = ruleMatch(r.pattern, route)
        if (m) matches.push({ rule: r, index: i, exact: m.exact, len: m.len })
      })
      matches.sort(function (a, b) { return (b.exact - a.exact) || (b.len - a.len) || (a.index - b.index) })
      out.win = matches[0] || null
      out.others = matches.slice(1)
      out.title = this.routeTitle(route)
      var notes = []
      if (!this.form.enabled) out.why = 'سعود متوقف من «الإعدادات».'
      else if (out.win && !out.win.rule.enabled) out.why = 'القاعدة «' + (out.win.rule.title || out.win.rule.pattern) + '» تُخفي سعود هنا.'
      out.visible = this.form.enabled && (!out.win || out.win.rule.enabled)
      if (out.visible) {
        if (this.form.hours.enabled) notes.push('في أوقات الظهور فقط')
        if (this.form.schools.mode == 'allow') notes.push('لمدارس محددة فقط')
        if (this.form.schools.mode == 'deny') notes.push('ما عدا ' + this.form.schools.ids.length + ' مدرسة')
        if (!this.form.show_on_mobile) notes.push('ليس على الجوال')
        out.why = notes.join(' · ')
      }
      return out
    },
    // Arabic title of a route from the whitelist (paths with :params match any value)
    routeTitle(route) {
      for (var i = 0; i < this.routes.length; i++) {
        var p = this.routes[i].path
        if (p == route) return this.routes[i].title
        if (p.indexOf('/:') >= 0) {
          var rx = new RegExp('^' + p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\/:[^/]+/g, '/[^/]+') + '$')
          if (rx.test(route)) return this.routes[i].title
        }
      }
      return ''
    },
    openRule(i) {
      var r = i >= 0 ? clone(this.form.page_rules[i]) : normRule({ title: '', pattern: '' })
      var base = r.pattern.replace(/\*$/, '')
      var known = this.routes.find(function (x) { return x.path == base || (x.path.indexOf('/:') >= 0 && x.path.slice(0, x.path.indexOf('/:') + 1) == base) })
      this.ruleEd = {
        open: true, index: i, q: '', prompt: '', error: '', r: r,
        mode: i < 0 ? (this.routes.length ? 'pick' : 'custom') : (known ? 'pick' : 'custom'),
        pick: known ? known.path : '',
      }
    },
    closeRule() { this.ruleEd.open = false },
    pickRoute(x) {
      var ed = this.ruleEd
      var prevTitle = (this.routes.find(function (y) { return y.path == ed.pick }) || {}).title
      ed.pick = x.path
      var cut = x.path.indexOf('/:')
      ed.r.pattern = cut >= 0 ? x.path.slice(0, cut + 1) + '*' : x.path + (this.isPrefix(ed.r.pattern) ? '*' : '')
      if (!ed.r.title || ed.r.title == prevTitle) ed.r.title = x.title
      ed.error = ''
    },
    setPrefix(on) {
      var base = this.ruleEd.r.pattern.replace(/\*$/, '')
      this.ruleEd.r.pattern = base + (on ? '*' : '')
    },
    addRulePrompt() {
      var q = this.ruleEd.prompt.trim().slice(0, RULE_MAX.prompt)
      var list = this.ruleEd.r.quick_prompts
      if (!q || list.length >= RULE_MAX.prompts) return
      if (list.indexOf(q) < 0) list.push(q)
      this.ruleEd.prompt = ''
    },
    addRuleLine(line) {
      var cur = (this.ruleEd.r.instructions || '').replace(/\s+$/, '')
      if (cur.indexOf(line) >= 0) return
      this.ruleEd.r.instructions = (cur ? cur + '\n' : '') + '• ' + line
    },
    // '' = valid; list = all rules (for duplicate patterns), i = this rule's index (-1 = new)
    ruleError(r, i, list) {
      var p = (r.pattern || '').trim()
      if (!p) return 'اختر صفحة أو اكتب النمط'
      if (!/^\/[^\s*]*\*?$/.test(p)) return 'النمط يبدأ بـ / وبدون مسافات، و* في آخره فقط'
      if (p.length > RULE_MAX.pattern) return 'النمط أطول من ' + RULE_MAX.pattern + ' حرف'
      if ((r.title || '').length > RULE_MAX.title) return 'اسم القاعدة أطول من ' + RULE_MAX.title + ' حرفاً'
      if ((r.instructions || '').length > RULE_MAX.instructions) return 'التعليمات أطول من ' + RULE_MAX.instructions + ' حرف'
      if ((r.welcome || '').length > RULE_MAX.welcome) return 'الترحيب أطول من ' + RULE_MAX.welcome + ' حرف'
      if ((r.quick_prompts || []).length > RULE_MAX.prompts) return 'حتى ' + RULE_MAX.prompts + ' اختصارات'
      var dup = list.some(function (x, j) { return j != i && (x.pattern || '').trim() == p })
      if (dup) return 'توجد قاعدة أخرى بنفس النمط ' + p
      return ''
    },
    applyRule() {
      var ed = this.ruleEd
      ed.r.pattern = (ed.r.pattern || '').trim()
      ed.r.title = (ed.r.title || '').trim() || this.routeTitle(ed.r.pattern.replace(/\*$/, '')) || ed.r.pattern
      if (ed.prompt.trim()) this.addRulePrompt()
      var err = this.ruleError(ed.r, ed.index, this.form.page_rules)
      if (err) { ed.error = err; return }
      var r = clone(ed.r)
      if (ed.index >= 0) this.form.page_rules.splice(ed.index, 1, r)
      else this.form.page_rules.push(r)
      ed.open = false
      // show the new / edited rule in «جرّب مسار»
      this.tester.route = r.pattern.replace(/\*$/, '') || this.tester.route
    },
    deleteRule(i, fromDrawer) {
      var r = this.form.page_rules[i]
      if (!r || !confirm('حذف قاعدة «' + (r.title || r.pattern) + '»؟ (تُحذف نهائياً بعد «حفظ التغييرات»)')) return
      this.form.page_rules.splice(i, 1)
      if (fromDrawer) this.ruleEd.open = false
    },
    moveRule(i, d) {
      var a = this.form.page_rules
      var j = i + d
      if (j < 0 || j >= a.length) return
      a.splice(j, 0, a.splice(i, 1)[0])
    },

    // ---------------------------------------------------------------- usage
    loadUsage(quiet) {
      var g = this
      this.usage.loading = true
      this.post('/usage', { from: this.usage.from, to: this.usage.to }).done(function (r) {
        if (!r || r.status != 100 || !r.response) return quiet ? null : g.fail(r)
        var d = r.response
        d.totals = Object.assign({ messages: 0, schools: 0, tokens: 0, cost_usd: 0, today_messages: 0 }, d.totals || {})
        d.per_school = Array.isArray(d.per_school) ? d.per_school : []
        d.per_day = (Array.isArray(d.per_day) ? d.per_day : []).slice().sort(function (a, b) { return a.day < b.day ? -1 : 1 })
        g.usage.data = d
        g.usage.missing = false
        var m = {}
        d.per_school.forEach(function (x) { if (x.school_id && x.name) m[x.school_id] = x.name })
        g.addNames(m)
      }).fail(function (xhr, ts) {
        if (g.isMissing(xhr, ts)) g.usage.missing = true
        else if (!quiet) g.fail()
      }).always(function () { g.usage.loading = false })
    },
    setRange(days) {
      this.usage.from = riyadhDay(1 - days)
      this.usage.to = riyadhDay(0)
      this.loadUsage()
    },
    rangeIs(days) { return this.usage.to == riyadhDay(0) && this.usage.from == riyadhDay(1 - days) },
    sortBy(k) {
      var s = this.usage.sort
      if (s.key == k) s.dir = s.dir == 'asc' ? 'desc' : 'asc'
      else this.usage.sort = { key: k, dir: k == 'name' ? 'asc' : 'desc' }
    },
    sortIcon(k) {
      var s = this.usage.sort
      if (s.key != k) return 'fa-sort sd-sort-idle'
      return s.dir == 'asc' ? 'fa-sort-asc' : 'fa-sort-desc'
    },
    pct(n) { return Math.min(100, Math.round(((Number(n) || 0) * 100) / (this.saved.daily_limit || 50))) },
    resetToday(r) {
      if (!confirm('إعادة تعيين حد اليوم لـ«' + (r.name || r.school_id) + '»؟\nأرسلت ' + r.today + ' رسالة اليوم، وبعد إعادة التعيين تستطيع إرسال ' + this.saved.daily_limit + ' رسالة جديدة.')) return
      var g = this
      this.resetting = r.school_id
      this.post('/reset_today', { school_id: r.school_id }).done(function (x) {
        if (!x || x.status != 100) return g.fail(x)
        if (g.usage.data) g.usage.data.totals.today_messages = Math.max(0, (Number(g.usage.data.totals.today_messages) || 0) - (Number(r.today) || 0))
        r.today = 0
        alert('تمت إعادة تعيين حد اليوم لـ«' + (r.name || r.school_id) + '»', 100)
      }).fail(function () { g.fail() }).always(function () { g.resetting = '' })
    },

    // ---------------------------------------------------------------- logs
    reloadLogs() {
      this.logs.page = 0
      this.loadLogs()
    },
    searchLater() {
      var g = this
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(function () { g.reloadLogs() }, 400)
    },
    resetLogFilters() {
      this.logs.school_id = ''
      this.logs.q = ''
      this.reloadLogs()
    },
    logPage(d) {
      this.logs.page = Math.max(0, this.logs.page + d)
      this.loadLogs()
    },
    loadLogs() {
      var g = this
      this.logs.loading = true
      this.post('/logs', { school_id: this.logs.school_id, q: this.logs.q.trim(), page: this.logs.page, limit: LIMIT }).done(function (r) {
        if (!r || r.status != 100 || !r.response) return g.fail(r)
        g.logs.rows = Array.isArray(r.response.rows) ? r.response.rows : []
        g.logs.total = Number(r.response.total) || 0
        g.logs.loaded = true
        g.logs.missing = false
        g.loadThumbs(g.logs.rows)
      }).fail(function (xhr, ts) {
        if (g.isMissing(xhr, ts)) { g.logs.missing = true; g.logs.loaded = true } else g.fail()
      }).always(function () { g.logs.loading = false })
    },
    openLog(row) {
      var g = this
      this.detail = { open: true, loading: true, row: row, log: null }
      this.post('/log', { id: row._id || row.id }).done(function (r) {
        if (!r || r.status != 100 || !r.response) { g.detail.open = false; return g.fail(r) }
        g.detail.log = Object.assign({}, row, r.response)
        g.loadThumbs([g.detail.log])
      }).fail(function (xhr, ts) {
        // an older server without the detail call: show what the list row has
        if (g.isMissing(xhr, ts)) g.detail.log = Object.assign({}, row)
        else { g.detail.open = false; g.fail() }
      }).always(function () { g.detail.loading = false })
    },
    schoolName(r) {
      if (!r) return ''
      if (r.school_id == 'admin-test') return 'تجربة الإدارة'
      if (r.school_name) return r.school_name
      var s = ((this.usage.data && this.usage.data.per_school) || []).find(function (x) { return x.school_id == r.school_id })
      return (s && s.name) || r.school_id || '—'
    },

    // ---------------------------------------------------------------- conversation files
    // (POST /user/saud/artifact from the school's browser; GET|POST /admin/saud/file streams one)
    fileKey(l, f) { return (l._id || l.id) + ':' + f.i },
    fileUrl(l, f) { return this.fileCache.urls[this.fileKey(l, f)] || '' },
    fileBusy(l, f) { return !!this.fileCache.busy[this.fileKey(l, f)] },
    fileIcon(f) { return { pdf: 'fa-file-pdf-o', image: 'fa-file-image-o', excel: 'fa-file-excel-o' }[f.kind] || 'fa-file-o' },
    fileKind(f) { return { pdf: 'PDF', image: 'صورة', excel: 'Excel' }[f.kind] || f.kind },
    // in the order of the answer's actions (uploads arrive in any order), then as uploaded
    sortedFiles(l) {
      var at = function (f) { return f.action >= 0 ? f.action : 99 }
      return (Array.isArray(l && l.files) ? l.files.slice() : []).sort(function (a, b) { return at(a) - at(b) || a.i - b.i })
    },
    fileSize(n) {
      n = Number(n) || 0
      return n >= 1048576 ? (n / 1048576).toFixed(1) + ' MB' : Math.max(1, Math.round(n / 1024)) + ' KB'
    },
    // the action of the detail a file was built from
    actionOf(f) {
      var a = f && f.action >= 0 ? this.detailActions[f.action] : null
      return isObj(a) ? a : null
    },
    chartSpec(a) {
      var col = function (k) { return k == 'count' ? 'العدد' : k }
      return [CHARTS[a.chart] || 'أعمدة', a.x ? 'المحور: ' + col(a.x) + (a.y ? ' ← ' + col(a.y) : '') : '', SCOPES[a.scope] || ''].filter(Boolean).join(' · ')
    },
    // older answers (no files) with a design: «معاينة التصميم» in the list
    rowDesign(r) {
      return !(r.files || []).length && this.actionTypes(r.actions).indexOf('design') >= 0
    },
    // → a blob URL of the file, cached for this page (POST {jwt, log, i}: the admin key never goes in a URL)
    fetchFile(l, f) {
      var g = this
      var k = this.fileKey(l, f)
      if (this.fileCache.urls[k]) return Promise.resolve(this.fileCache.urls[k])
      if (this.fileJobs[k]) return this.fileJobs[k]
      this.$set(this.fileCache.busy, k, true)
      var job = fetch(api + '/admin/saud/file', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        body: JSON.stringify({ jwt: this.jwt, log: l._id || l.id, i: f.i }),
      }).then(function (r) {
        // errors (and the admin guard) answer JSON
        if (!r.ok || (r.headers.get('content-type') || '').indexOf('application/json') >= 0) {
          return r.json().catch(function () { return {} }).then(function (j) {
            throw new Error(g.errText(j) || (r.status == 404 ? 'الملف غير موجود (ربما حُذف مع السجل)' : 'تعذر تحميل الملف'))
          })
        }
        return r.blob()
      }).then(function (b) {
        var url = URL.createObjectURL(b)
        g.$set(g.fileCache.urls, k, url)
        g.fileCache.order.push(k)
        // the page stays light: the oldest copies go after 60
        while (g.fileCache.order.length > 60) {
          var old = g.fileCache.order.shift()
          URL.revokeObjectURL(g.fileCache.urls[old])
          g.$delete(g.fileCache.urls, old)
        }
        return url
      })
      this.fileJobs[k] = job
      job.catch(function () {}).then(function () {
        delete g.fileJobs[k]
        g.$delete(g.fileCache.busy, k)
      })
      return job
    },
    // the image thumbnails of these logs, 3 at a time
    loadThumbs(list) {
      var g = this
      var q = []
      ;(list || []).forEach(function (l) {
        (l.files || []).forEach(function (f) { if (f.kind == 'image' && !g.fileUrl(l, f)) q.push([l, f]) })
      })
      var next = function () {
        var x = q.shift()
        if (x) g.fetchFile(x[0], x[1]).catch(function () {}).then(next)
      }
      for (var n = 0; n < 3; n++) next()
    },
    viewFile(l, f) {
      if (f.kind == 'excel') return this.downloadFile(l, f)
      var g = this
      this.viewer = {
        show: true, kind: f.kind, title: f.name, url: '', html: '', log: l, file: f, loading: true, error: '',
        meta: this.fileKind(f) + ' · ' + this.fileSize(f.size) + ' · ' + this.when(f.at),
      }
      this.fetchFile(l, f).then(function (url) {
        if (g.viewer.file !== f) return
        g.viewer.url = url
        g.viewer.loading = false
      }).catch(function (e) {
        if (g.viewer.file !== f) return
        g.viewer.error = e.message
        g.viewer.loading = false
      })
    },
    downloadFile(l, f) {
      var g = this
      this.fetchFile(l, f).then(function (url) {
        var a = document.createElement('a')
        a.href = url
        a.download = f.name || 'saud'
        document.body.appendChild(a)
        a.click()
        a.remove()
      }).catch(function (e) { g.fail({ response: e.message }) })
    },
    closeViewer() {
      this.viewer = { show: false, kind: '', title: '', url: '', html: '', log: null, file: null, loading: false, error: '', meta: '' }
    },
    openDesign(l, a) {
      this.viewer = {
        show: true, kind: 'design', title: 'معاينة التصميم — ' + this.actionTitle(a), url: '', html: designDoc(a, l, this.saved.templates),
        log: l, file: null, loading: false, error: '', meta: 'تصميم ' + (a.format == 'pdf' ? 'PDF' : 'صورة') + ' · ' + this.when(l.at),
      }
    },
    // the list row has no action_data: read the log, then the first saved design
    previewRowDesign(r) {
      var g = this
      this.viewer = { show: true, kind: 'design', title: 'معاينة التصميم', url: '', html: '', log: r, file: null, loading: true, error: '', meta: '' }
      this.post('/log', { id: r._id || r.id }).done(function (x) {
        var l = x && x.status == 100 && isObj(x.response) ? Object.assign({}, r, x.response) : null
        var a = l && (l.action_data || []).find(function (y) { return isObj(y) && y.type == 'design' && y.html })
        if (!a) {
          g.viewer.loading = false
          g.viewer.error = (x && g.errText(x)) || 'لم يُحفظ HTML التصميم في هذا السجل'
          return
        }
        if (g.viewer.show) g.openDesign(l, a)
      }).fail(function () {
        g.viewer.loading = false
        g.viewer.error = 'تعذر الاتصال بالسيرفر'
      })
    },

    // ---------------------------------------------------------------- test
    // «القاعدة المطبقة» of a test: the server's page_rule (object or text), else what this page computed
    serverRule(x) {
      var p = x.res && x.res.page_rule
      if (p && typeof p == 'object') return 'القاعدة: ' + (p.title || p.pattern || p.id) + (p.enabled === false ? ' (مخفي للمدارس)' : '')
      if (typeof p == 'string' && p) return 'القاعدة: ' + p
      if (x.res && 'page_rule' in x.res) return 'بلا قاعدة صفحة'
      return x.rule ? 'القاعدة: ' + x.rule : 'بلا قاعدة صفحة'
    },
    samplePage() { return JSON.stringify(Object.assign({}, SAMPLE_PAGE, this.test && this.test.route ? { route: cleanRoute(this.test.route) } : {}), null, 2) },
    // the route field writes page.route of the snapshot (when the JSON is valid)
    syncTestRoute() {
      try {
        var p = JSON.parse(this.test.page)
        if (!isObj(p)) return
        p.route = cleanRoute(this.test.route) || p.route
        this.test.page = JSON.stringify(p, null, 2)
      } catch (e) { /* invalid JSON: shown by pageError, route still sent */ }
    },
    formatPage() {
      try { this.test.page = JSON.stringify(JSON.parse(this.test.page), null, 2) } catch (e) { /* shown by pageError */ }
    },
    sendTest() {
      var msg = this.test.message.trim()
      if (!msg || this.test.sending || this.pageError) return
      var g = this
      var snapshot = null
      try { snapshot = this.test.page.trim() ? JSON.parse(this.test.page) : null } catch (e) { return }
      var route = cleanRoute(this.test.route)
      var body = { message: msg }
      // PageSnapshot travels as a JSON string, like POST /user/saud/chat; its route = the route field
      if (route) {
        snapshot = Object.assign(snapshot || {}, { route: route })
        body.route = route
      }
      if (snapshot) body.page = JSON.stringify(snapshot)
      var info = this.routeInfo(route)
      var ruleName = info.win ? (info.win.rule.title || info.win.rule.pattern) + (info.win.rule.enabled ? '' : ' (مخفي للمدارس)') : ''
      var t0 = Date.now()
      this.test.sending = true
      this.test.pending = msg
      this.post('/test', body).done(function (r) {
        var item = { id: t0, message: msg, snapshot: snapshot, route: route, rule: ruleName, ms: Date.now() - t0, raw: false, res: null, error: '' }
        if (!r || r.status != 100 || !r.response || typeof r.response != 'object') item.error = g.errText(r) || 'لم يرد سعود'
        else item.res = Object.assign({ text: '', actions: [] }, r.response)
        g.test.results.unshift(item)
        g.test.missing = false
      }).fail(function (xhr, ts) {
        if (g.isMissing(xhr, ts)) g.test.missing = true
        else g.test.results.unshift({ id: t0, message: msg, snapshot: snapshot, route: route, rule: ruleName, ms: Date.now() - t0, raw: false, res: null, error: ts == 'timeout' ? 'انتهت مهلة الانتظار' : 'تعذر الاتصال بالسيرفر' })
      }).always(function () { g.test.sending = false })
    },

    // ---------------------------------------------------------------- actions
    actionTypes(list) {
      return (Array.isArray(list) ? list : []).map(function (a) { return a && typeof a == 'object' ? a.type : a }).filter(Boolean)
    },
    actMeta(t) {
      return ACTIONS[t] || { icon: 'fa-bolt', cls: 'other', short: t || 'إجراء', name: t || 'إجراء', button: 'تنفيذ' }
    },
    actionTitle(a) {
      return (a && (a.title || a.label)) || this.actMeta(a && a.type).name
    },
    // human lines for an action, column keys → labels from the snapshot it was asked with
    actionLines(a, snap) {
      var tables = (snap && Array.isArray(snap.tables)) ? snap.tables : []
      var table = tables.find(function (t) { return t && t.id == a.table }) || null
      var col = function (k) {
        if (k == 'count') return 'العدد'
        var c = table && Array.isArray(table.columns) ? table.columns.find(function (x) { return x.key == k }) : null
        return c ? c.label : k
      }
      var val = function (v) { return Array.isArray(v) ? v.join('، ') : String(v) }
      var lines = []
      if (a.type == 'open_page') {
        lines.push(['الصفحة', a.route || '—'])
        return lines
      }
      if (a.table) lines.push(['الجدول', table ? table.title || a.table : a.table])
      if (a.type == 'design') lines.push(['الصيغة', a.format == 'pdf' ? 'PDF' : 'صورة'])
      if (a.scope) lines.push(['النطاق', SCOPES[a.scope] || a.scope])
      if (a.type == 'chart') {
        if (a.chart) lines.push(['النوع', CHARTS[a.chart] || a.chart])
        if (a.x) lines.push(['المحور', col(a.x) + (a.y ? ' ← ' + col(a.y) : '')])
      }
      if (Array.isArray(a.columns) && a.columns.length) lines.push(['الأعمدة', a.columns.map(col).join('، ')])
      if (a.sort && a.sort.key) lines.push(['الترتيب', col(a.sort.key) + (a.sort.dir == 'desc' ? ' (تنازلي)' : ' (تصاعدي)')])
      if (a.filter && a.filter.key) lines.push(['الفلتر', col(a.filter.key) + ' ' + (OPS[a.filter.op] || a.filter.op || '=') + ' ' + val(a.filter.value)])
      if (a.group_by) lines.push(['تجميع حسب', col(a.group_by)])
      if (a.template) lines.push(['القالب', TEMPLATES[a.template] || a.template])
      if (Array.isArray(a.highlight) && a.highlight.length) lines.push(['تمييز', a.highlight.map(function (h) { return col(h.key) + ' = ' + h.value }).join('، ')])
      if (a.note) lines.push(['ملاحظة', a.note])
      if (a.type == 'design' && typeof a.html == 'string') lines.push(['HTML', this.num(a.html.length) + ' حرف (قالب بعلامات، بلا بيانات)'])
      return lines
    },

    // ---------------------------------------------------------------- formatting
    tok(log, k) { return (log && log.tokens && Number(log.tokens[k])) || 0 },
    // input already contains the cached part; thinking is billed as output
    tokTotal(t) {
      if (!t) return 0
      if (typeof t == 'number') return t
      return (Number(t.input) || 0) + (Number(t.output) || 0) + (Number(t.thoughts) || 0)
    },
    pretty(v) {
      try { return JSON.stringify(v, null, 2) } catch (e) { return String(v) }
    },
    parseMaybe(v) {
      if (typeof v != 'string') return v
      try { return JSON.parse(v) } catch (e) { return v }
    },
    when(iso) {
      if (!iso) return '—'
      var d = new Date(iso)
      if (isNaN(d)) return iso
      return new Date(d.getTime() + 3 * 3600 * 1000).toISOString().slice(0, 16).replace('T', ' ')
    },
    ago(d) {
      if (!d) return ''
      var m = Math.max(0, Math.floor((Date.now() - new Date(d).getTime()) / 60000))
      if (m < 1) return 'الآن'
      if (m < 60) return 'منذ ' + m + ' د'
      if (m < 1440) return 'منذ ' + Math.floor(m / 60) + ' س'
      return 'منذ ' + Math.floor(m / 1440) + ' يوم'
    },
    // $0.12 · tiny amounts keep more decimals ($0.0004); totals get thousands separators
    usd(v, total) {
      var n = Number(v) || 0
      var d = 2
      if (!total && n > 0 && n < 0.01) d = n < 0.001 ? 5 : 4
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d })
    },
    num(v) { return (Number(v) || 0).toLocaleString('en-US') },
    compact(v) {
      var n = Number(v) || 0
      if (n >= 1e6) return (n / 1e6).toFixed(n >= 1e7 ? 1 : 2) + 'M'
      if (n >= 1e4) return Math.round(n / 1e3) + 'K'
      return this.num(n)
    },
  },
}
</script>

<style scoped>
/* written LTR: postcss-rtl flips left/right for the RTL admin */
.sd-page { padding-bottom: 70px; }
.sd-hero {
  display: flex; flex-wrap: wrap; gap: 16px; justify-content: space-between; align-items: flex-end;
  background: var(--ad-green-900); color: #fff; border-radius: 16px; padding: 20px 22px; margin-bottom: 14px;
}
.sd-hero h3 { color: #fff; margin-bottom: 6px; font-weight: 700; display: flex; align-items: center; gap: 10px; }
.sd-hero p { color: rgba(255, 255, 255, 0.82); max-width: 820px; margin-bottom: 0; line-height: 1.8; }
.sd-hero-text { flex: 1 1 480px; min-width: 0; }
.sd-hero-meta { display: flex; gap: 10px; flex-wrap: wrap; }
.sd-hero-meta > div { background: rgba(255, 255, 255, 0.1); border-radius: 12px; padding: 8px 14px; min-width: 100px; }
.sd-hero-meta span { display: block; font-size: 0.78rem; color: rgba(255, 255, 255, 0.7); }
.sd-hero-meta b { color: #fff; font-size: 0.95rem; }
.sd-mark {
  display: inline-flex; align-items: center; justify-content: center; width: 34px; height: 34px; border-radius: 11px; flex: none;
  background: linear-gradient(135deg, #22955F, #146C43); color: #fff; font-size: 1.05rem; font-weight: 700;
  box-shadow: 0 0 0 2px rgba(242, 193, 78, 0.85);
}
.sd-mark.lg { width: 52px; height: 52px; border-radius: 16px; font-size: 1.5rem; }

.sd-tabs {
  display: flex; gap: 6px; overflow-x: auto; padding: 6px; margin-bottom: 14px;
  background: var(--ad-surface); border: 1px solid var(--ad-line); border-radius: 14px;
}
.sd-tab {
  border: 0; background: transparent; white-space: nowrap; padding: 8px 14px; border-radius: 10px;
  color: var(--ad-muted); font-weight: 500; display: inline-flex; align-items: center; gap: 7px;
}
.sd-tab:hover { background: var(--ad-mint); color: var(--ad-green); }
.sd-tab.active { background: var(--ad-green); color: #fff; box-shadow: 0 4px 12px rgba(20, 108, 67, 0.25); }
.sd-tab:focus-visible { outline: 2px solid var(--ad-green); outline-offset: 2px; }
.sd-count { background: var(--ad-mint); color: var(--ad-green-900); border-radius: 999px; padding: 0 9px; font-size: 0.78rem; font-weight: 700; }
.sd-tab.active .sd-count { background: rgba(255, 255, 255, 0.22); color: #fff; }

.sd-empty { align-items: center; text-align: center; padding: 36px 20px; }
.sd-empty.sm { padding: 26px 16px; }
.sd-empty.in-card { display: flex; flex-direction: column; border-top: 1px solid var(--ad-line); }
.sd-empty h5, .sd-empty h6 { font-weight: 700; color: var(--ad-green-900); margin: 12px 0 6px; }
.sd-empty p { color: var(--ad-muted); max-width: 520px; margin: 0 auto 14px; line-height: 1.8; }
.sd-empty-icon {
  width: 64px; height: 64px; border-radius: 20px; display: inline-flex; align-items: center; justify-content: center;
  background: var(--ad-mint); color: var(--ad-green); font-size: 1.7rem; margin: 0 auto;
}
.sd-empty-icon.warn { background: #FFF4E5; color: var(--ad-warn); }

.sd-card-head { display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; }
.sd-tools { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.sd-inline { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.sd-grow { flex: 1 1 180px; min-width: 0; }
.sd-num { width: 90px; text-align: center; font-weight: 700; }
.sd-nowrap { white-space: nowrap; }
.btn-flat { background: transparent; border: 0; color: var(--ad-muted); padding: 3px 6px; }
.btn-flat:hover:not(:disabled) { color: var(--ad-green); }
.sd-big-switch .custom-control-label { font-size: 1.1rem; font-weight: 700; padding-top: 2px; }
.sd-on { border: 1px solid var(--ad-green); box-shadow: 0 0 0 3px rgba(20, 108, 67, 0.12); }
.sd-switch-help { padding-left: 2.6rem; margin-top: 2px; line-height: 1.7; }

/* knowledge radio cards (as «متى يرد المساعد الذكي؟») */
.sd-modes { display: flex; flex-direction: column; gap: 8px; }
.sd-mode {
  display: flex; gap: 12px; align-items: flex-start; margin: 0; cursor: pointer;
  border: 1px solid var(--ad-line); border-radius: 12px; padding: 12px 14px; transition: border-color 0.15s ease, background 0.15s ease;
}
.sd-mode:hover { border-color: var(--ad-green-600); }
.sd-mode.on { border-color: var(--ad-green); background: var(--ad-mint); box-shadow: 0 0 0 3px rgba(20, 108, 67, 0.1); }
.sd-mode-radio { width: 18px; height: 18px; margin-top: 4px; flex: none; accent-color: var(--ad-green); cursor: pointer; }
.sd-mode-body { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.sd-mode-title { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; font-weight: 700; color: var(--ad-ink); line-height: 1.6; }
.sd-mode.on .sd-mode-title { color: var(--ad-green-900); }
.sd-mode small { color: var(--ad-muted); line-height: 1.6; }
.sd-tag { background: var(--ad-green); color: #fff; border-radius: 999px; padding: 0 9px; font-size: 0.72rem; font-weight: 600; }
.sd-size { background: #EEF1EF; color: var(--ad-muted); border-radius: 999px; padding: 0 9px; font-size: 0.74rem; font-weight: 600; }

/* quick prompts */
.sd-chips { display: flex; flex-wrap: wrap; gap: 6px; }
.sd-chip {
  display: inline-flex; align-items: center; gap: 2px; border: 1px solid #CFE7D9; background: var(--ad-mint);
  color: var(--ad-green-900); border-radius: 999px; padding: 2px 4px; font-size: 0.86rem;
}
.sd-chip-text { padding: 2px 6px; cursor: text; }
.sd-chip button { border: 0; background: transparent; color: var(--ad-muted); width: 22px; height: 22px; border-radius: 50%; padding: 0; font-size: 0.72rem; }
.sd-chip button:hover:not(:disabled) { background: #fff; color: var(--ad-green); }
.sd-chip .sd-chip-x:hover { color: var(--ad-bad); }
.sd-chip button:disabled { opacity: 0.3; }

/* Gemini key */
.sd-key { display: flex; gap: 12px; align-items: flex-start; padding: 12px 14px; border-radius: 12px; }
.sd-key > .fa { font-size: 1.5rem; margin-top: 2px; }
.sd-key > div { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.sd-key small { color: var(--ad-muted); line-height: 1.7; }
.sd-key code { align-self: flex-start; }
.sd-key.ok { background: #E3F4EA; }
.sd-key.ok > .fa, .sd-key.ok b { color: var(--ad-ok); }
.sd-key.bad { background: #FFF4E5; }
.sd-key.bad > .fa, .sd-key.bad b { color: var(--ad-warn); }

/* the school-side panel preview (opens on the left in the school app) */
.sd-panel { position: relative; max-width: 380px; margin: 0 auto; border: 1px solid var(--ad-line); border-radius: 18px; overflow: hidden; box-shadow: 0 10px 30px rgba(11, 61, 42, 0.12); background: #fff; }
.sd-panel.off > :not(.sd-panel-offnote) { filter: grayscale(1); opacity: 0.45; }
.sd-panel-head { display: flex; align-items: center; gap: 10px; padding: 12px 14px; background: linear-gradient(135deg, #146C43, #0B3D2A); color: #fff; }
.sd-panel-av { width: 38px; height: 38px; border-radius: 12px; background: rgba(255, 255, 255, 0.16); display: inline-flex; align-items: center; justify-content: center; font-weight: 700; font-size: 1.1rem; box-shadow: 0 0 0 2px rgba(242, 193, 78, 0.8); flex: none; }
.sd-panel-name { display: flex; flex-direction: column; min-width: 0; flex: 1; line-height: 1.4; }
.sd-panel-name b { color: #fff; }
.sd-panel-name small { color: rgba(255, 255, 255, 0.75); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sd-panel-left { font-size: 0.7rem; background: rgba(255, 255, 255, 0.14); border-radius: 999px; padding: 2px 8px; white-space: nowrap; }
.sd-panel-body { display: flex; flex-direction: column; gap: 8px; padding: 12px; background: #F7FAF8; min-height: 220px; }
.sd-panel-chips { display: flex; flex-wrap: wrap; gap: 5px; }
.sd-panel-chips span { border: 1px solid #CFE7D9; background: #fff; color: var(--ad-green); border-radius: 999px; padding: 2px 10px; font-size: 0.76rem; }
.sd-panel-foot { padding: 8px 12px 12px; border-top: 1px solid var(--ad-line); background: #fff; }
.sd-panel-shot { display: flex; align-items: center; gap: 6px; font-size: 0.76rem; color: var(--ad-muted); margin-bottom: 6px; }
.sd-panel-input { display: flex; justify-content: space-between; align-items: center; border: 1px solid var(--ad-line); border-radius: 999px; padding: 7px 14px; color: #9AA59F; font-size: 0.84rem; }
.sd-panel-input .fa { color: var(--ad-green); }
.sd-panel-offnote { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); background: var(--ad-ink); color: #fff; border-radius: 999px; padding: 6px 14px; font-size: 0.85rem; white-space: nowrap; }
.sd-mini-action { display: flex; align-items: center; gap: 6px; margin-top: 6px; padding: 6px 8px; border-radius: 10px; background: #fff; border: 1px solid #CFE7D9; font-size: 0.8rem; }
.sd-mini-action .fa { color: #1D6F42; }
.sd-mini-action span { margin-left: auto; background: var(--ad-green); color: #fff; border-radius: 8px; padding: 1px 8px; font-size: 0.72rem; }

/* chat bubbles (panel preview, test, detail) */
.sd-bubble { max-width: 88%; padding: 8px 12px; border-radius: 14px; font-size: 0.88rem; line-height: 1.8; white-space: pre-wrap; overflow-wrap: anywhere; }
.sd-bubble.saud { align-self: flex-start; background: #fff; border: 1px solid var(--ad-line); border-top-left-radius: 4px; color: var(--ad-ink); }
.sd-bubble.me { align-self: flex-end; background: var(--ad-green); color: #fff; border-top-right-radius: 4px; }
.sd-bubble.wide { max-width: none; }
.sd-thread { display: flex; flex-direction: column; gap: 8px; padding: 12px; border-radius: 14px; background: #F7FAF8; margin-bottom: 12px; }
.sd-thread.old { opacity: 0.85; }
.sd-typing { display: inline-flex; gap: 4px; align-items: center; }
.sd-typing span { width: 7px; height: 7px; border-radius: 50%; background: var(--ad-green); animation: sd-dot 1s infinite ease-in-out; }
.sd-typing span:nth-child(2) { animation-delay: 0.15s; }
.sd-typing span:nth-child(3) { animation-delay: 0.3s; }
@keyframes sd-dot { 0%, 80%, 100% { opacity: 0.25; transform: translateY(0); } 40% { opacity: 1; transform: translateY(-3px); } }

/* instructions */
.sd-count-line { display: flex; justify-content: flex-end; margin-top: 2px; }
.sd-examples { display: flex; flex-wrap: wrap; gap: 6px; align-items: center; margin-top: 6px; }
.sd-ex {
  border: 1px dashed var(--ad-green-600); background: #fff; color: var(--ad-green-900); border-radius: 999px;
  padding: 2px 10px; font-size: 0.78rem; line-height: 1.7; text-align: left;
}
.sd-ex:hover { background: var(--ad-mint); border-style: solid; }
.sd-ex .fa { font-size: 0.65rem; color: var(--ad-green); }
.sd-chips.sm .sd-ex { border-style: solid; border-color: var(--ad-line); color: var(--ad-muted); }
.sd-chips.sm .sd-ex:hover { color: var(--ad-green-900); border-color: var(--ad-green-600); }

/* template controls */
.sd-seg { display: inline-flex; flex-wrap: wrap; gap: 4px; padding: 4px; border: 1px solid var(--ad-line); border-radius: 12px; background: #FAFCFB; }
.sd-seg label { position: relative; margin: 0; padding: 5px 12px; border-radius: 9px; cursor: pointer; color: var(--ad-muted); font-size: 0.86rem; display: inline-flex; align-items: center; gap: 6px; }
.sd-seg label input { position: absolute; opacity: 0; width: 1px; height: 1px; }
.sd-seg label.on { background: var(--ad-green); color: #fff; }
.sd-seg label:focus-within { outline: 2px solid var(--ad-green); outline-offset: 1px; }
.sd-color { display: flex; align-items: center; gap: 8px; }
.sd-color input[type='color'] { width: 40px; height: 32px; padding: 2px; border: 1px solid var(--ad-line); border-radius: 8px; background: #fff; cursor: pointer; flex: none; }
.sd-color .form-control { max-width: 110px; font-family: monospace; }
.sd-swatches { display: flex; gap: 6px; margin-top: 6px; flex-wrap: wrap; }
.sd-swatches button { width: 22px; height: 22px; border-radius: 50%; border: 2px solid #fff; box-shadow: 0 0 0 1px var(--ad-line); padding: 0; }
.sd-swatches button.on { box-shadow: 0 0 0 2px var(--ad-ink); }
.sd-range-ends { display: flex; justify-content: space-between; color: var(--ad-muted); margin-top: -4px; }

/* live PDF preview (pure HTML; the paper is A4 at 72 dpi, scaled to the card) */
.sd-paper-box { display: flex; justify-content: center; overflow: hidden; background: #E9EEEB; border-radius: 12px; padding: 0; }
.sd-paper {
  flex: none; transform-origin: top center; background: #fff; color: #1D2A23; box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  padding: 30px 34px 22px; display: flex; flex-direction: column; line-height: 1.6;
}
.sd-doc-head { display: flex; align-items: center; gap: 14px; padding-bottom: 10px; border-bottom: 3px solid; }
.sd-doc-logo { flex: none; }
.sd-doc-logo >>> .app-logo-mark { width: 54px; height: 54px; filter: none; }
.sd-doc-school-logo { width: 56px; height: 56px; border: 2px dashed; border-radius: 50%; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 1.4em; line-height: 1; }
.sd-doc-school-logo small { font-size: 7px; margin-top: 3px; color: #66766D; }
.sd-doc-titles { flex: 1; display: flex; flex-direction: column; min-width: 0; }
.sd-doc-org { font-size: 0.75em; color: #66766D; }
.sd-doc-school { font-size: 1.3em; }
.sd-doc-line { font-size: 0.9em; color: #1D2A23; }
.sd-doc-dates { display: flex; flex-direction: column; align-items: flex-end; font-size: 0.78em; color: #66766D; text-align: right; white-space: nowrap; }
.sd-doc-title { margin: 14px 0 2px; font-size: 1.35em; font-weight: 700; text-align: center; }
.sd-doc-sub { text-align: center; color: #66766D; font-size: 0.8em; margin-bottom: 12px; }
.sd-doc-cards { display: flex; gap: 10px; margin-bottom: 12px; }
.sd-doc-cards > div { flex: 1; border: 1px solid #E1E9E4; border-top: 3px solid; border-radius: 6px; padding: 6px 10px; display: flex; justify-content: space-between; align-items: baseline; font-size: 0.85em; }
.sd-doc-cards b { font-size: 1.3em; }
.sd-doc-table { width: 100%; border-collapse: collapse; font-size: 1em; }
.sd-doc-table th { color: #fff; font-weight: 600; padding: 5px 8px; text-align: left; font-size: 0.9em; }
.sd-doc-table td { padding: 5px 8px; border-bottom: 1px solid #E1E9E4; }
.sd-doc-pill { display: inline-block; border-radius: 999px; padding: 0 8px; font-size: 0.85em; font-weight: 600; }
.sd-doc-note { margin-top: 12px; padding: 6px 10px; border-left: 3px solid; border-radius: 4px; font-size: 0.82em; }
.sd-doc-foot { margin-top: auto; padding-top: 8px; border-top: 2px solid; display: flex; justify-content: space-between; font-size: 0.75em; color: #66766D; }

/* usage */
.sd-filters { display: flex; gap: 10px; flex-wrap: wrap; align-items: flex-end; padding-bottom: 6px; }
.sd-filters .form-group { margin-bottom: 6px; min-width: 140px; }
.sd-filters label { font-size: 0.78rem; margin-bottom: 2px; }
.sd-filter-tools { margin-bottom: 6px; }
.sd-usage-card {
  display: flex; flex-wrap: wrap; align-items: center; gap: 12px 22px; margin-bottom: 14px; padding: 14px 18px;
  background: var(--ad-surface); border: 1px solid var(--ad-line); border-left: 4px solid var(--ad-green); border-radius: 14px;
}
.sd-usage-main { display: flex; flex-direction: column; min-width: 0; margin-right: auto; }
.sd-usage-label { font-weight: 700; color: var(--ad-green-900); }
.sd-usage-label .fa { color: var(--ad-green); }
.sd-usage-cost { font-size: 1.7rem; line-height: 1.3; color: var(--ad-green-900); text-align: left; }
.sd-usage-main small { color: var(--ad-muted); }
.sd-stat { display: flex; flex-direction: column; padding-left: 22px; border-left: 1px dashed var(--ad-line); min-width: 90px; }
.sd-stat span { font-size: 0.8rem; color: var(--ad-muted); }
.sd-stat b { font-size: 1.25rem; color: var(--ad-ink); }
.sd-stat.today b { color: var(--ad-green); }
.sd-search { max-width: 260px; }
.sd-table th { white-space: nowrap; font-size: 0.82rem; color: var(--ad-muted); }
.sd-table td { vertical-align: middle; }
.sd-sort { border: 0; background: transparent; padding: 0; color: inherit; font: inherit; font-weight: 600; white-space: nowrap; }
.sd-sort.on { color: var(--ad-green-900); }
.sd-sort .fa { margin-left: 3px; }
.sd-sort .sd-sort-idle { opacity: 0.35; }
.sd-today { font-size: 0.86rem; }
.sd-bar { width: 90px; height: 5px; border-radius: 999px; background: #EEF1EF; overflow: hidden; margin-top: 3px; }
.sd-bar span { display: block; height: 100%; background: var(--ad-green-600); border-radius: 999px; }
.sd-bar span.full { background: var(--ad-bad); }
@media (max-width: 575.98px) {
  .sd-usage-main { width: 100%; margin-right: 0; }
  .sd-stat { padding-left: 0; border-left: 0; flex: 1 1 40%; }
  .sd-search { max-width: none; width: 100%; }
}

/* logs */
.sd-click { cursor: pointer; }
.sd-click:hover td { background: #FAFCFB; }
.sd-log td:nth-child(2) { min-width: 160px; }
.sd-log td:nth-child(4) { min-width: 220px; max-width: 360px; }
.sd-route { background: #EEF1EF; color: var(--ad-ink); border-radius: 6px; padding: 1px 6px; font-size: 0.78rem; white-space: nowrap; }
.sd-clamp { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; line-height: 1.7; }
.sd-act { display: inline-flex; align-items: center; gap: 4px; border-radius: 999px; padding: 1px 8px; margin: 1px 0 1px 3px; font-size: 0.74rem; font-weight: 600; white-space: nowrap; background: #EEF1EF; color: var(--ad-muted); }
.sd-act.excel { background: #E3F4EA; color: #1D6F42; }
.sd-act.pdf { background: #FDECEC; color: #B42318; }
.sd-act.image { background: #EFE9FB; color: #6B46C1; }
.sd-act.chart { background: #E6F0FA; color: var(--ad-info); }
.sd-act.page { background: #FFF4E5; color: var(--ad-warn); }
.sd-act.shot { background: #F1F3F2; color: var(--ad-muted); }
.sd-act.err { background: #FDECEC; color: var(--ad-bad); }
.sd-pager { display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; }

/* action cards (test + detail) */
.sd-action { align-self: stretch; border: 1px solid var(--ad-line); border-left: 4px solid var(--ad-muted); border-radius: 12px; background: #fff; padding: 10px 12px; }
.sd-action.sm { padding: 8px 10px; margin-bottom: 6px; }
.sd-action-head { display: flex; align-items: center; gap: 10px; }
.sd-action-head > .fa { font-size: 1.4rem; width: 26px; text-align: center; }
.sd-action-head > div { display: flex; flex-direction: column; min-width: 0; flex: 1; }
.sd-action-head small { color: var(--ad-muted); }
.sd-action-btn { margin-left: auto; white-space: nowrap; border-radius: 8px; padding: 3px 10px; font-size: 0.8rem; font-weight: 600; background: #EEF1EF; color: var(--ad-muted); cursor: default; }
.sd-action.excel { border-left-color: #1D6F42; } .sd-action.excel .sd-action-head > .fa { color: #1D6F42; } .sd-action.excel .sd-action-btn { background: #1D6F42; color: #fff; }
.sd-action.pdf { border-left-color: #B42318; } .sd-action.pdf .sd-action-head > .fa { color: #B42318; } .sd-action.pdf .sd-action-btn { background: #B42318; color: #fff; }
.sd-action.image { border-left-color: #6B46C1; } .sd-action.image .sd-action-head > .fa { color: #6B46C1; } .sd-action.image .sd-action-btn { background: #6B46C1; color: #fff; }
.sd-action.chart { border-left-color: var(--ad-info); } .sd-action.chart .sd-action-head > .fa { color: var(--ad-info); } .sd-action.chart .sd-action-btn { background: var(--ad-info); color: #fff; }
.sd-action.page { border-left-color: var(--ad-warn); } .sd-action.page .sd-action-head > .fa { color: var(--ad-warn); } .sd-action.page .sd-action-btn { background: var(--ad-warn); color: #fff; }
.sd-action-lines { display: grid; grid-template-columns: auto 1fr; gap: 2px 12px; margin: 8px 0 0; font-size: 0.82rem; }
.sd-action-lines dt { color: var(--ad-muted); font-weight: 500; }
.sd-action-lines dd { margin: 0; color: var(--ad-ink); overflow-wrap: anywhere; }
.sd-meta { display: flex; flex-wrap: wrap; gap: 4px 14px; align-items: center; font-size: 0.78rem; color: var(--ad-muted); }
.sd-json { text-align: start; white-space: pre-wrap; overflow-wrap: anywhere; font-size: 0.78rem; line-height: 1.6; background: #0F1F17; color: #CFE7D9; border-radius: 10px; padding: 10px 12px; margin: 6px 0 0; max-height: 340px; overflow: auto; }
.sd-code { font-family: SFMono-Regular, Menlo, Consolas, monospace; font-size: 0.78rem; line-height: 1.55; text-align: start; }

/* unsaved changes bar */
.sd-savebar {
  position: sticky; bottom: 12px; z-index: 20; display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap;
  margin-top: 6px; padding: 10px 14px; border-radius: 14px; background: var(--ad-green-900); color: #fff; box-shadow: 0 10px 30px rgba(11, 61, 42, 0.3);
}
.sd-savebar .btn-outline-secondary { color: #fff; border-color: rgba(255, 255, 255, 0.5); }
.sd-savebar .btn-outline-secondary:hover { background: rgba(255, 255, 255, 0.12); }
.sd-savebar .btn-primary { background: #fff !important; color: var(--ad-green-900) !important; border-color: #fff !important; }

/* detail drawer (as the call detail in «مركز الاتصالات») */
.sd-drawer-bg { position: fixed; inset: 0; background: rgba(0, 0, 0, 0.25); z-index: 1040; }
.sd-drawer {
  position: fixed; top: 0; bottom: 0; left: 0; width: min(560px, 100%); background: var(--ad-surface);
  z-index: 1041; box-shadow: 0 0 30px rgba(0, 0, 0, 0.18); transform: translateX(-105%); transition: transform 0.2s ease;
  display: flex; flex-direction: column;
}
.sd-drawer.open { transform: none; }
.sd-drawer-head { display: flex; justify-content: space-between; align-items: center; gap: 10px; padding: 14px 16px; border-bottom: 1px solid var(--ad-line); }
.sd-drawer-body { padding: 14px 16px; overflow-y: auto; flex: 1; }
.sd-kvs { display: grid; grid-template-columns: 1fr 1fr; gap: 6px; }
.sd-kvs > div { display: flex; flex-direction: column; padding: 6px 10px; border-radius: 10px; background: #F7FAF8; min-width: 0; }
.sd-kvs span { font-size: 0.74rem; color: var(--ad-muted); }
.sd-kvs b { font-size: 0.86rem; overflow-wrap: anywhere; }
.sd-kvs code { align-self: flex-start; margin-top: 2px; white-space: normal; overflow-wrap: anywhere; }
.sd-sec { display: flex; align-items: center; gap: 6px; margin: 16px 0 8px; font-size: 0.92rem; font-weight: 700; color: var(--ad-green-900); }
.sd-usage { display: grid; grid-template-columns: repeat(4, 1fr); gap: 6px; padding: 8px; border: 1px solid var(--ad-line); border-radius: 12px; background: #FAFCFB; }
.sd-usage > div { display: flex; flex-direction: column; gap: 1px; padding: 6px 8px; border-radius: 8px; background: var(--ad-surface); font-size: 0.85rem; }
.sd-usage span { font-size: 0.74rem; color: var(--ad-muted); }
.sd-usage .sd-usage-total { grid-column: 1 / -1; flex-direction: row; justify-content: space-between; align-items: center; background: var(--ad-mint); }
.sd-usage .sd-usage-total span { font-size: 0.8rem; color: var(--ad-green-900); }
.sd-usage .sd-usage-total b { color: var(--ad-green-900); }
@media (max-width: 420px) { .sd-usage { grid-template-columns: 1fr 1fr; } }
@media (prefers-reduced-motion: reduce) { .sd-drawer { transition: none; } .sd-typing span { animation: none; } }

/* ---------------------------------------------------------------- v2: الإمكانيات والخيارات */
.sd-sub { border-top: 1px solid var(--ad-line); margin-top: 14px; padding-top: 12px; }
.sd-dim { opacity: 0.55; }
.sd-num.wide { width: 110px; }
.sd-note { background: var(--ad-mint); border-left: 3px solid var(--ad-green); border-radius: 8px; padding: 8px 12px; color: var(--ad-green-900); font-size: 0.86rem; line-height: 1.9; }
.sd-caps { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.sd-cap { display: flex; gap: 10px; align-items: flex-start; padding: 10px 12px; border: 1px solid var(--ad-line); border-radius: 12px; background: #FAFCFB; transition: border-color 0.15s ease, background 0.15s ease; }
.sd-cap.on { background: #fff; border-color: #CFE7D9; box-shadow: 0 2px 8px rgba(11, 61, 42, 0.06); }
.sd-cap-icon { font-size: 1.35rem; width: 24px; text-align: center; margin-top: 2px; color: #9AA59F; }
.sd-cap-body { display: flex; flex-direction: column; min-width: 0; }
.sd-cap-body .custom-control-label { font-weight: 700; }
.sd-cap-body small { color: var(--ad-muted); line-height: 1.6; padding-left: 2.6rem; }
.sd-cap.on.excel .sd-cap-icon { color: #1D6F42; }
.sd-cap.on.pdf .sd-cap-icon { color: #B42318; }
.sd-cap.on.image .sd-cap-icon { color: #6B46C1; }
.sd-cap.on.chart .sd-cap-icon { color: var(--ad-info); }
.sd-cap.on.page .sd-cap-icon { color: var(--ad-warn); }
.sd-cap.on.design .sd-cap-icon { color: #C2410C; }
@media (max-width: 575.98px) { .sd-caps { grid-template-columns: 1fr; } }

/* mini previews of the floating button (physical left / right come from inline styles: not flipped) */
.sd-minis { display: flex; gap: 12px; align-items: flex-end; }
.sd-mini-desk, .sd-mini-phone { position: relative; overflow: hidden; background: #F3F6F4; border: 1px solid var(--ad-line); }
.sd-mini-desk { flex: 1; height: 130px; border-radius: 10px; }
.sd-mini-phone { width: 70px; height: 130px; border-radius: 14px; border-width: 3px; border-color: #1D2A23; flex: none; }
.sd-mini-phone.hidden { opacity: 0.7; }
.sd-mini-top { height: 14px; background: #fff; border-bottom: 1px solid var(--ad-line); }
.sd-mini-side { position: absolute; top: 14px; bottom: 0; width: 20%; background: #fff; border-left: 1px solid var(--ad-line); }
.sd-mini-lines { display: flex; flex-direction: column; gap: 6px; padding: 10px 12px; }
.sd-mini-desk .sd-mini-lines { width: 76%; }
.sd-mini-lines span { height: 6px; border-radius: 4px; background: #DDE6E0; }
.sd-mini-lines span.s { width: 60%; }
.sd-mini-fab, .sd-mini-sup { position: absolute; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; }
.sd-mini-fab { width: 26px; height: 26px; background: linear-gradient(135deg, #22955F, #146C43); color: #fff; font-size: 0.72rem; font-weight: 700; box-shadow: 0 0 0 2px rgba(242, 193, 78, 0.85), 0 3px 8px rgba(11, 61, 42, 0.35); }
.sd-mini-fab.sm { width: 20px; height: 20px; font-size: 0.6rem; }
.sd-mini-sup { width: 20px; height: 20px; background: #CBD5D0; color: #fff; font-size: 0.6rem; }
.sd-mini-phone .sd-mini-sup { width: 18px; height: 18px; }
.sd-mini-off { position: absolute; bottom: 30px; left: 0; right: 0; text-align: center; font-size: 0.66rem; color: var(--ad-bad); font-weight: 700; }

.sd-hours { margin-top: 10px; }
.sd-days { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 10px; }
.sd-day { border: 1px solid var(--ad-line); border-radius: 999px; padding: 3px 12px; font-size: 0.84rem; background: var(--ad-surface); color: var(--ad-muted); }
.sd-day.on { background: var(--ad-green); border-color: var(--ad-green); color: #fff; }
.sd-day:focus-visible { outline: 2px solid var(--ad-green); outline-offset: 2px; }
.sd-hours input[type='time'] { width: 130px; }
.sd-seg-wrap { display: flex; }
.sd-seg-wrap label { flex: 1 1 auto; justify-content: center; }
.sd-school-list { border: 1px solid var(--ad-line); border-radius: 12px; max-height: 220px; overflow-y: auto; margin-bottom: 8px; }
.sd-school { display: flex; align-items: center; gap: 10px; padding: 6px 10px; border-bottom: 1px dashed var(--ad-line); }
.sd-school:last-child { border-bottom: 0; }
.sd-school > .fa { color: var(--ad-green); }
.sd-school > div { display: flex; flex-direction: column; flex: 1; min-width: 0; line-height: 1.5; }
.sd-school small { color: var(--ad-muted); font-size: 0.72rem; text-align: left; }
.sd-results { border: 1px solid var(--ad-line); border-radius: 10px; margin-top: 6px; max-height: 230px; overflow-y: auto; box-shadow: 0 6px 18px rgba(11, 61, 42, 0.08); }
.sd-result { display: flex; width: 100%; align-items: center; justify-content: space-between; gap: 10px; border: 0; border-bottom: 1px solid var(--ad-line); background: #fff; padding: 6px 10px; text-align: left; }
.sd-result:last-child { border-bottom: 0; }
.sd-result:hover:not(:disabled) { background: var(--ad-mint); }
.sd-result:disabled { opacity: 0.6; }
.sd-result span { display: flex; flex-direction: column; min-width: 0; }
.sd-result small { color: var(--ad-muted); }
.sd-result .fa-plus { color: var(--ad-green); }

/* ---------------------------------------------------------------- v2: تعليمات الصفحات */
.sd-rules { border-top: 1px solid var(--ad-line); }
.sd-rule { display: flex; align-items: center; gap: 10px; padding: 10px 14px; border-bottom: 1px solid var(--ad-line); background: #fff; border-left: 3px solid transparent; }
.sd-rule.off .sd-rule-title b { color: var(--ad-muted); }
.sd-rule.hit { background: #F4FAF6; border-left-color: var(--ad-green); }
.sd-rule.sortable-ghost { opacity: 0.4; }
.sd-rule-drag { cursor: grab; color: #9AA59F; padding: 4px; }
.sd-rule-main { flex: 1; min-width: 0; cursor: pointer; }
.sd-rule-main:focus-visible { outline: 2px solid var(--ad-green); outline-offset: 2px; border-radius: 6px; }
.sd-rule-title { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 8px; }
.sd-rule-badges { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 4px; }
.sd-badge { display: inline-flex; align-items: center; gap: 4px; border: 0; border-radius: 999px; padding: 1px 9px; font-size: 0.74rem; font-weight: 600; background: #EEF1EF; color: var(--ad-muted); white-space: nowrap; }
button.sd-badge:hover { background: var(--ad-mint); color: var(--ad-green-900); }
.sd-badge.ok { background: #E3F4EA; color: var(--ad-ok); }
.sd-badge.warn { background: #FFF4E5; color: var(--ad-warn); }
.sd-badge.bad { background: #FDECEC; color: var(--ad-bad); }
.sd-rule-switch { min-width: 92px; }
.sd-rule-tools { display: flex; white-space: nowrap; }
@media (max-width: 575.98px) {
  .sd-rule { flex-wrap: wrap; }
  .sd-rule-main { flex-basis: calc(100% - 40px); }
  .sd-rule-switch { margin-left: 30px; }
  .sd-rule-tools { margin-left: auto; }
}
.sd-verdict-box { margin-top: 12px; }
.sd-verdict { display: flex; align-items: center; gap: 8px; padding: 8px 12px; border-radius: 10px; font-weight: 700; }
.sd-verdict.ok { background: #E3F4EA; color: var(--ad-ok); }
.sd-verdict.bad { background: #FDECEC; color: var(--ad-bad); }
.sd-win { margin: 12px 0 6px; display: flex; flex-direction: column; gap: 4px; }
.sd-win-rule { display: flex; flex-direction: column; align-items: flex-start; gap: 3px; text-align: left; border: 1px solid #CFE7D9; background: var(--ad-mint); border-radius: 10px; padding: 8px 10px; color: var(--ad-green-900); }
.sd-win-rule:hover { border-color: var(--ad-green); }
.sd-win-rule small { color: var(--ad-muted); }
.sd-others { display: flex; flex-wrap: wrap; gap: 4px; align-items: center; margin-top: 8px; }
.sd-test-rule { display: flex; flex-wrap: wrap; align-items: center; gap: 4px 8px; margin-top: 6px; }

/* rule drawer */
.sd-rule-drawer { width: min(600px, 100%); }
.sd-drawer-foot { display: flex; gap: 8px; justify-content: flex-end; align-items: center; padding: 12px 16px; border-top: 1px solid var(--ad-line); background: #FAFCFB; }
.sd-foot-start { margin-right: auto; }
.sd-picker { border: 1px solid var(--ad-line); border-radius: 12px; max-height: 250px; overflow-y: auto; margin-top: 6px; }
.sd-pick { display: flex; width: 100%; justify-content: space-between; align-items: center; gap: 10px; border: 0; border-bottom: 1px solid var(--ad-line); background: #fff; padding: 7px 12px; text-align: left; font-size: 0.88rem; }
.sd-pick:last-child { border-bottom: 0; }
.sd-pick:hover { background: #F4FAF6; }
.sd-pick.on { background: var(--ad-mint); color: var(--ad-green-900); font-weight: 700; box-shadow: inset 3px 0 0 var(--ad-green); }
.sd-pick code { font-size: 0.74rem; color: var(--ad-muted); background: transparent; white-space: nowrap; }
.sd-covers { display: flex; flex-direction: column; gap: 2px; margin-top: 10px; padding: 8px 12px; border-radius: 10px; background: #F7FAF8; }
.sd-rule-show { padding: 10px 12px; border: 1px solid #CFE7D9; border-radius: 12px; background: #F4FAF6; }
.sd-rule-show.off { border-color: #F5C2C2; background: #FDF3F3; }
.sd-rule-show small { display: block; color: var(--ad-muted); padding-left: 2.6rem; line-height: 1.7; }
.sd-savebar-where { opacity: 0.75; }
.sd-act.design { background: #FFEDD5; color: #C2410C; }
.sd-action.design { border-left-color: #C2410C; } .sd-action.design .sd-action-head > .fa { color: #C2410C; } .sd-action.design .sd-action-btn { background: #C2410C; color: #fff; }

/* conversation files: list row (thumbnails / chips), detail cards, the viewer */
.sd-log td:nth-child(5) { min-width: 180px; }
.sd-rfiles { display: flex; flex-wrap: wrap; align-items: center; gap: 4px; margin-top: 6px; padding-top: 6px; border-top: 1px dashed var(--ad-line); }
.sd-rfiles-ic { color: #9AA59F; font-size: 0.85rem; margin-left: 2px; }
.sd-rthumb {
  width: 40px; height: 34px; padding: 0; border: 1px solid var(--ad-line); border-radius: 7px; background: #F3F6F4; overflow: hidden;
  display: inline-flex; align-items: center; justify-content: center; color: #6B46C1; cursor: zoom-in;
}
.sd-rthumb img { width: 100%; height: 100%; object-fit: cover; object-position: top; }
.sd-rthumb:hover, .sd-rthumb:focus-visible { border-color: #6B46C1; box-shadow: 0 0 0 2px rgba(107, 70, 193, 0.15); }
.sd-rfile {
  display: inline-flex; align-items: center; gap: 4px; height: 26px; border: 1px solid var(--ad-line); border-radius: 7px; padding: 0 8px;
  font-size: 0.74rem; font-weight: 700; background: #EEF1EF; color: var(--ad-muted); cursor: pointer; white-space: nowrap;
}
.sd-rfile.pdf { background: #FDECEC; color: #B42318; border-color: #F7CACA; }
.sd-rfile.excel { background: #E3F4EA; color: #1D6F42; border-color: #BFE3CD; }
.sd-rfile.design { background: #FFEDD5; color: #C2410C; border-color: #FBD3A9; }
.sd-rfile:hover, .sd-rfile:focus-visible { filter: brightness(0.96); box-shadow: 0 1px 4px rgba(11, 61, 42, 0.12); }
.sd-rfile-dl { font-size: 0.68rem; opacity: 0.8; }
.sd-files { display: flex; flex-direction: column; gap: 8px; }
.sd-file { display: flex; gap: 10px; align-items: center; padding: 8px; border: 1px solid var(--ad-line); border-radius: 12px; background: #fff; }
.sd-file-thumb, .sd-file-icon, .sd-file-chart {
  width: 112px; height: 78px; flex: none; border-radius: 9px; overflow: hidden; display: inline-flex; align-items: center; justify-content: center;
}
.sd-file-thumb { padding: 0; border: 1px solid var(--ad-line); background: #F3F6F4; color: #6B46C1; cursor: zoom-in; font-size: 1.4rem; }
.sd-file-thumb img { width: 100%; height: 100%; object-fit: cover; object-position: top; }
.sd-file-thumb:hover, .sd-file-thumb:focus-visible { border-color: #6B46C1; }
.sd-file-icon { font-size: 2rem; background: #EEF1EF; color: var(--ad-muted); }
.sd-file.pdf .sd-file-icon { background: #FDECEC; color: #B42318; }
.sd-file.excel .sd-file-icon { background: #E3F4EA; color: #1D6F42; }
.sd-file.design .sd-file-icon { background: #FFEDD5; color: #C2410C; }
.sd-file-chart { background: #F7FAF8; border: 1px dashed #C9D6CF; }
.sd-file-body { display: flex; flex-direction: column; gap: 1px; min-width: 0; flex: 1; }
.sd-file-body b { font-size: 0.86rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.sd-file-body small { color: var(--ad-muted); line-height: 1.6; }
.sd-file-body .sd-file-note { color: #8A968F; font-size: 0.72rem; }
.sd-file-btns { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 4px; }
.sd-file-btns .btn { padding: 2px 10px; font-size: 0.78rem; }
.sd-viewer-msg { padding: 48px 10px; text-align: center; color: var(--ad-muted); }
.sd-viewer-frame { display: block; width: 100%; height: 72vh; border: 1px solid var(--ad-line); border-radius: 10px; background: #E9EEEB; }
.sd-viewer-img { max-height: 74vh; overflow: auto; text-align: center; background: #F3F6F4; border-radius: 10px; padding: 10px; }
.sd-viewer-img img { max-width: 100%; height: auto; box-shadow: 0 4px 18px rgba(11, 61, 42, 0.12); }
.sd-viewer-meta { margin-right: auto; }
</style>
